<template>
  <!-- NOTE (TEMPLATE) to register a new proposal -->

  <div class="animated fadeIn">
    <div>
      <span v-show="false">{{ reactivity }}</span>
      <!-- loading component -->
      <Loading />

      <b-card style="border: 0" class="mt-0 mb-0">
        <b-card
          v-if="
            proposal.status == 'نیاز به تکمیل / اصلاح' && proposal.adminMessage
          "
          header-bg-variant="danger"
          header-text-variant="white"
          header="اصلاحات مورد نیاز"
          style="border: 0"
          class="shadow p-3 mb-5 bg-white rounded mt-0"
          >{{ errorMessage }}</b-card
        >
        <div class="d-flex justify-content-center mt-3"></div>
        <b-tabs class="mb-3" pills vertical v-model="tabIndex">
          <div class="d-flex justify-content-center mt-3">
            <!-- NOTE (b-previousTab) to go to the previous tab -->
            <b-button
              v-if="tabIndex != 0"
              class="mx-1"
              variant="light"
              @click="changePage('back')"
              >مرحله قبل</b-button
            >
            <!-- NOTE (b-nextTab) to go to the next tab -->
            <b-button
              v-if="tabIndex != 8"
              class="mx-1"
              variant="primary"
              @click="changePage('next')"
              >مرحله بعد</b-button
            >
          </div>
          <b-tab :title="'حمایت‌های پیشین از دوره‌'" active>
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">حمایت‌های پیشین</h4>
              </template>

              <b-card
                header-bg-variant="#8341a4"
                header-text-variant="white"
                header="پژوهشگر مورد نظر"
                style="border: 0"
                class="shadow p-3 mb-5 bg-white rounded mt-0"
              >
                <b-form-group>
                  <Select2
                    class="myselect2"
                    v-model="proposal.researcherId"
                    :options="researchers"
                    :settings="{ width: '100%' }"
                    @change="showAcount()"
                  ></Select2>
                </b-form-group>
              </b-card>
              <b-form-group>
                <div class="d-flex" dir="ltr">
                  <label
                    for="switch_1"
                    :class="
                      proposal.initialObligation
                        ? 'ml-3 mb-0 done'
                        : 'ml-3 mb-0 required'
                    "
                  >
                    اینجانب تعهد می کنم با مطالعه و آگاهی از
                    <b-button
                      id="downLoad"
                      title="دانلود تعهدات"
                      variant="link"
                      :href="
                        filePath + `/setad/private/1613477912994aein_forsat.pdf`
                      "
                    >
                      <b-tooltip
                        placement="bottomleft"
                        target="downLoad"
                        triggers="hover"
                        variant="info"
                        >دانلود شیوه‌نامه</b-tooltip
                      >شیوه‌نامه حمایت از فرصت‌های مطالعاتی ستاد توسعه زیست
                      فناوری </b-button
                    >و طرح تقسیم کار ملی زیست‌فناوری نسبت به ارسال درخواست در
                    سامانه اقدام می نمایم
                  </label>
                  <b-form-checkbox
                    id="switch_1"
                    v-model="proposal.initialObligation"
                  ></b-form-checkbox>
                </div>
              </b-form-group>
              <hr />
              <h3 class="text-primary mb-4">پژوهشگر گرامی</h3>

              <p>
                به ابزار حمایت از مقالات سامانه تقسیم کار ملی خوش آمدید.
                خواهشندیم ابتدا به سوالات زیر پاسخ دهید:
              </p>
              <b-form-group
                label="آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها استفاده کرده است؟"
                class="done"
              >
                <b-form-radio-group v-model="proposal.initialIsSupported">
                  <b-form-radio :value="true">بله</b-form-radio>
                  <b-form-radio :value="false">خیر</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-form-group
                label="حمایت ها:"
                v-if="proposal.initialIsSupported"
                :class="proposal.initialSupportedType ? 'done' : 'required'"
              >
                <b-form-select
                  class="myselect2"
                  id="first"
                  v-model="proposal.initialSupportedType"
                  :options="options"
                >
                </b-form-select>
              </b-form-group>
              <b-form-group
                label="عنوان حمایت دریافتی"
                v-if="
                  proposal.initialSupportedType == 'other' &&
                  proposal.initialIsSupported
                "
                :class="proposal.initialOtherSupport ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  type="text"
                  v-model="proposal.initialOtherSupport"
                >
                </b-form-input>
              </b-form-group>
              <b-form-group
                label="توضیحات حمایت دریافتی:"
                v-if="proposal.initialIsSupported"
                :class="
                  proposal.initialSupportDescription ? 'done' : 'required'
                "
              >
                <b-form-textarea
                  trim
                  rows="6"
                  v-model="proposal.initialSupportDescription"
                >
                </b-form-textarea>
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="'اطلاعات اصلی دوره'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">اطلاعات اصلی دوره</h4>
              </template>
              <b-form-group label="عنوان به زبان فارسی">
                <b-form-input trim v-model="proposal.faSubject"> </b-form-input>
              </b-form-group>
              <b-form-group
                :class="proposal.enSubject ? 'done' : 'required'"
                label="عنوان به زبان انگلیسی"
              >
                <b-form-input
                  trim
                  type="text"
                  dir="ltr"
                  v-model="proposal.enSubject"
                  @keydown="nameKeydown($event)"
                ></b-form-input>
              </b-form-group>
              <b-row class="mb-2">
                <b-col>
                  <span
                    :class="
                      proposal.universityId
                        ? proposal.universityId != 1
                          ? 'done'
                          : proposal.otherUniversity
                          ? 'done'
                          : 'required'
                        : 'required'
                    "
                    >دانشگاه محل اجرای دوره</span
                  >
                </b-col>
                <b-col class="text-left">
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="proposal.universityId"
                    name="checkbox-1"
                    :value="notUniversity"
                    unchecked-value=""
                    @change="reactivity = !reactivity"
                  >
                    سایر دانشگاه ها
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-form-group>
                <Select2
                  v-model="proposal.universityId"
                  :options="universities"
                  :settings="{ width: '100%' }"
                  @change="removeMehvar()"
                  :disabled="proposal.universityId == notUniversity"
                ></Select2>
                <b-form-input
                  trim
                  class="mt-1"
                  v-model="proposal.otherUniversity"
                  v-show="proposal.universityId == notUniversity"
                  placeholder="نام دانشگاه مورد نظر"
                  @input="reactivity = !reactivity"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                :disabled="!proposal.universityId"
                label="محور دوره (لطفا یک گزینه را انتخاب کنید)"
                :class="
                  proposal.mehvarId
                    ? proposal.mehvarId != notMehvar
                      ? 'done'
                      : proposal.otherMehvars
                      ? 'done'
                      : 'required'
                    : 'required'
                "
              >
                <b-list-group>
                  <b-list-group-item
                    style="cursor: pointer"
                    v-for="(mehvar, index) in computedMehvars"
                    :variant="selectedMehvar == index ? 'info' : 'light'"
                    :key="index"
                    @click="
                      proposal.mehvarId = mehvar.id;
                      selectedMehvar = index;
                    "
                    :disabled="mehvar.id == 0"
                  >
                    <span v-if="selectedMehvar == index">
                      <i class="fa fa-check-circle text-success"></i>
                    </span>
                    <span v-else>
                      <i class="fa fa-circle"></i>
                    </span>
                    {{ mehvar.text }}
                  </b-list-group-item>
                </b-list-group>

                <b-form-input
                  trim
                  class="mt-1"
                  v-model="proposal.otherMehvars"
                  v-show="proposal.mehvarId == notMehvar"
                  placeholder="نام محور مورد نظر"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="ماهیت دوره:"
                :class="
                  proposal.typeStudy ||
                  proposal.typeSystemicDevelopmental ||
                  proposal.typePractical
                    ? 'done'
                    : 'required'
                "
              >
                <b-form-checkbox v-model="proposal.typeStudy"
                  >مطالعاتی</b-form-checkbox
                >
                <b-form-checkbox v-model="proposal.typeSystemicDevelopmental"
                  >سیستمی و توسعه‌ای</b-form-checkbox
                >
                <b-form-checkbox v-model="proposal.typePractical"
                  >کاربردی</b-form-checkbox
                >
              </b-form-group>
              <b-form-group
                label="حوزه دوره:"
                :class="
                  proposal.zoneMedicine ||
                  proposal.zoneAgriculture ||
                  proposal.zoneEnvironment ||
                  proposal.zoneIndustrial ||
                  proposal.zoneBioComputing ||
                  proposal.zoneOther
                    ? 'done'
                    : 'required'
                "
              >
                <b-form-checkbox v-model="proposal.zoneMedicine"
                  >پزشکی</b-form-checkbox
                >
                <b-form-checkbox v-model="proposal.zoneAgriculture"
                  >کشاورزی</b-form-checkbox
                >
                <b-form-checkbox v-model="proposal.zoneEnvironment"
                  >محیط زیست</b-form-checkbox
                >
                <b-form-checkbox v-model="proposal.zoneIndustrial"
                  >صنعتی</b-form-checkbox
                >
                <b-form-checkbox v-model="proposal.zoneBioComputing"
                  >رایانش زیستی</b-form-checkbox
                >
                <b-form-checkbox v-model="proposal.zoneOther"
                  >سایر</b-form-checkbox
                >
              </b-form-group>
              <b-form-group
                label="گزارش خلاصه اقداماتی که قصد دارید در دانشگاه مقصد  در طی دوره انجام دهید"
                :class="proposal.oppurtunityActions ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  v-model="proposal.oppurtunityActions"
                ></b-form-textarea
              ></b-form-group>
              <b-form-group
                label="دستاورد های دوره به تفکیک:"
                :class="achievmentItemsClass"
              >
                <!-- NOTE (b-addAchievment) to add achievment to achievment items table -->
                <b-button variant="success" class="mb-3 ml-1" @click="add()"
                  >+</b-button
                >

                <!-- NOTE (t-achievmentItems) to show achievment and output of proposal  -->
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="proposal.oppurtunityAchievements"
                  :fields="achievmentFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(operation)="data">
                    <!-- NOTE (b-delAvhievment) to remove a row from achievment items table -->
                    <b-button
                      variant="danger"
                      class="mr-2"
                      @click="remove(data.index)"
                      >x</b-button
                    >
                  </template>

                  <template v-slot:cell(name)="data">
                    <b-form-input
                      trim
                      v-model="data.item.name"
                      type="text"
                    ></b-form-input>
                  </template>
                </b-table>
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="'اطلاعات متقاضی'">
            <b-card-body>
              <b-card header-bg-variant="default" class="border-0 shadow-sm">
                <template v-slot:header>
                  <h4 class="mb-0">اطلاعات متقاضی</h4>
                </template>

                <b-card-text>
                  <div class="row">
                    <div class="col">
                      <b-form-group
                        label="نام"
                        :class="proposal.researcherName ? 'done' : 'required'"
                      >
                        <b-form-input
                          trim
                          type="text"
                          v-model="proposal.researcherName"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <b-form-group
                        label="نام خانوادگی"
                        :class="
                          proposal.researcherLastName ? 'done' : 'required'
                        "
                      >
                        <b-form-input
                          trim
                          type="text"
                          v-model="proposal.researcherLastName"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <b-form-group
                        label="کدملی"
                        :class="
                          isIDClass(proposal.researcherNatCode)
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b-form-input
                          trim
                          type="text"
                          v-model="proposal.researcherNatCode"
                          aria-describedby="input-1-live-feedback"
                          :state="isID(proposal.researcherNatCode)"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback"
                          >کد ملی درست نیست</b-form-invalid-feedback
                        >
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <b-row>
                        <b-col>
                          <b-form-group
                            id="fieldset-horizontal"
                            :class="
                              proposal.researcherMobile ? 'done' : 'required'
                            "
                            description
                            label="تلفن همراه:"
                          >
                            <b-form-input
                              trim
                              v-model="proposal.researcherMobile"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6"></div>
                  </div>

                  <b-form-group
                    label="پست الکترونیکی"
                    :class="
                      isEmailClass(proposal.researcherEmail)
                        ? 'done'
                        : 'required'
                    "
                  >
                    <b-form-input
                      trim
                      :state="isEmail(proposal.researcherEmail)"
                      aria-describedby="input-1-live-feedback"
                      type="text"
                      v-model="proposal.researcherEmail"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-1-live-feedback"
                      >پست الکترونیکی درست نیست</b-form-invalid-feedback
                    >
                  </b-form-group>

                  <b-form-group
                    label="دورنگار"
                    :class="proposal.researcherFax ? 'done' : 'required'"
                  >
                    <b-form-input
                      trim
                      v-model="proposal.researcherFax"
                      type="number"
                      :no-wheel="true"
                    ></b-form-input>
                  </b-form-group>

                  <b-row>
                    <b-col cols="6">
                      <b-form-group
                        id="fieldset-horizontal"
                        :class="
                          proposal.researcherStateId ? 'done' : 'required'
                        "
                        description
                        label="استان:"
                      >
                        <!-- <b-form-input trim  v-model="executor.state"></b-form-input> -->
                        <v-autocomplete
                          v-model="proposal.researcherStateId"
                          :items="iran"
                          @change="
                            proposal.researcherCityId = '';
                            proposal.researcherCity = '';
                            proposal.researcherState = iran.filter(
                              (x) => x.id == proposal.researcherStateId
                            )[0].name;
                            reactivity2 = !reactivity2;
                          "
                          item-value="id"
                          item-text="name"
                          dense
                          outlined
                          class="dropdown-style"
                          hide-details
                        ></v-autocomplete>
                      </b-form-group> </b-col
                    ><b-col>
                      <b-form-group
                        id="fieldset-horizontal"
                        :class="proposal.researcherCityId ? 'done' : 'required'"
                        description
                        label="شهر:"
                      >
                        <span v-show="false">{{ reactivity2 }}</span>

                        <v-autocomplete
                          v-model="proposal.researcherCityId"
                          :items="
                            iran
                              .filter((x) => x.id == proposal.researcherStateId)
                              .map((y) => y.cities)[0]
                          "
                          item-value="id"
                          item-text="name"
                          dense
                          outlined
                          class="dropdown-style"
                          hide-details
                          @change="
                            reactivity2 = !reactivity2;
                            proposal.researcherCity = iran
                              .filter(
                                (x) => x.id == proposal.researcherStateId
                              )[0]
                              .cities.filter(
                                (y) => y.id == proposal.researcherCityId
                              )[0].name;
                          "
                        ></v-autocomplete>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <span :class="universityClass">دانشگاه محل تحصیل</span>
                    </b-col>
                    <b-col class="text-left">
                      <b-form-checkbox
                        id="checkbox-2"
                        v-model="proposal.researcherUniversityId"
                        name="checkbox-2"
                        :value="notUniversity"
                        unchecked-value=""
                        @change="reactivity = !reactivity"
                      >
                        سایر دانشگاه ها
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                  <b-form-group>
                    <Select2
                      v-model="proposal.researcherUniversityId"
                      :options="universities"
                      :settings="{ width: '100%' }"
                      :disabled="
                        proposal.researcherUniversityId == notUniversity
                      "
                    ></Select2>
                    <b-form-input
                      trim
                      class="mt-1"
                      v-model="proposal.researcherUniversityOther"
                      v-show="proposal.researcherUniversityId == notUniversity"
                      placeholder="نام دانشگاه"
                      @input="reactivity = !reactivity"
                    ></b-form-input>
                  </b-form-group>
                  <b-row class="mb-2">
                    <b-col>
                      <span :class="universityJobClass"
                        >دانشگاه محل اشتغال</span
                      >
                    </b-col>
                    <b-col class="text-left">
                      <b-form-checkbox
                        id="checkbox-3"
                        v-model="proposal.researcherUniversityJobId"
                        name="checkbox-3"
                        :value="notUniversity"
                        unchecked-value=""
                        @change="reactivity = !reactivity"
                      >
                        سایر دانشگاه ها
                      </b-form-checkbox>
                    </b-col>
                  </b-row>

                  <b-form-group>
                    <Select2
                      v-model="proposal.researcherUniversityJobId"
                      :options="universities"
                      :settings="{ width: '100%' }"
                      :disabled="
                        proposal.researcherUniversityJobId == notUniversity
                      "
                    ></Select2>
                    <b-form-input
                      trim
                      class="mt-1"
                      v-model="proposal.researcherUniversityJobOther"
                      v-show="
                        proposal.researcherUniversityJobId == notUniversity
                      "
                      placeholder="نام دانشگاه"
                      @input="reactivity = !reactivity"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    id="fieldset-horizontal"
                    :class="proposal.researcherIBAN ? 'done' : 'required'"
                    description
                    label="شماره شبا:"
                  >
                    <b-form-input
                      trim
                      v-model="proposal.researcherIBAN"
                      type="number"
                      :no-wheel="true"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    id="fieldset-horizontal"
                    :class="proposal.researcherBankName ? 'done' : 'required'"
                    description
                    label="نام بانک:"
                  >
                    <b-form-input
                      trim
                      v-model="proposal.researcherBankName"
                      type="text"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    :class="
                      proposal.researcherUniversityDestination
                        ? 'done'
                        : 'required'
                    "
                    label="دانشگاه مقصد"
                  >
                    <b-form-input
                      trim
                      v-model="proposal.researcherUniversityDestination"
                      required
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    :class="
                      proposal.researcherCountryDestination
                        ? 'done'
                        : 'required'
                    "
                    label="کشور مقصد"
                  >
                    <Select2
                      v-model="proposal.researcherCountryDestination"
                      :options="countries.map((x) => x.fa)"
                      :settings="{ width: '100%' }"
                    ></Select2>
                  </b-form-group>
                  <br />
                  <b-form-radio-group
                    v-model="proposal.researcherMasterStudent"
                    style="text-align: center"
                  >
                    <b-form-radio value="master">استاد</b-form-radio>
                    <b-form-radio value="student">دانشجو</b-form-radio>
                  </b-form-radio-group>
                  <br />
                  <b-form-group
                    label="شاخص Hindex استاد"
                    v-if="proposal.researcherMasterStudent == 'master'"
                  >
                    <b-form-input
                      trim
                      type="number"
                      :no-wheel="true"
                      v-model="proposal.researcherHindex"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    label="شاخص Hindex دانشجو"
                    v-if="proposal.researcherMasterStudent == 'student'"
                  >
                    <b-form-input
                      trim
                      type="number"
                      :no-wheel="true"
                      v-model="proposal.researcherHindex"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    label="نمره امتحان جامع دانشجو"
                    v-if="proposal.researcherMasterStudent == 'student'"
                  >
                    <b-form-input
                      trim
                      type="number"
                      :no-wheel="true"
                      v-model="proposal.researcherComprehensiveTestMark"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    label="تاریخ امتحان جامع دانشجو"
                    v-if="proposal.researcherMasterStudent == 'student'"
                  >
                    <datePicker
                      color="#7b1fa2"
                      v-model="proposal.researcherComprehensiveTestDate"
                    >
                    </datePicker>
                  </b-form-group>
                  <br />
                  <hr />
                  <br />
                  <b-form-group
                    label="عنوان طرح رساله دکتری"
                    :class="
                      proposal.researcherPhDThesisSubject ? 'done' : 'required'
                    "
                  >
                    <b-form-input
                      trim
                      type="text"
                      v-model="proposal.researcherPhDThesisSubject"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    label="تاریخ تصویب رساله"
                    :class="
                      proposal.researcherPhDThesisDefenceDate
                        ? 'done'
                        : 'required'
                    "
                    v-if="proposal.researcherMasterStudent == 'student'"
                  >
                    <datePicker
                      color="#7b1fa2"
                      v-model="proposal.researcherPhDThesisDefenceDate"
                    >
                    </datePicker>
                  </b-form-group>
                  <br />
                  <b-form-group>
                    <!-- NOTE (b-addService) to add a row to service items table -->
                    <p>فهرست مقالات نمایه شده در ISI</p>
                    <b-button
                      variant="success"
                      class="mb-3 ml-1"
                      @click="addArticle()"
                      >+</b-button
                    >
                    <!-- NOTE (t-serviceItems) to show informations of phase scheduling, activities description and weight percentage of activity  -->
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="proposal.researcherArticleISI"
                      :fields="articlesFields"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                      <template v-slot:cell(upload)="row">
                        <b-button variant="primary" @click="row.toggleDetails"
                          >بارگذاری</b-button
                        >
                      </template>
                      <template #row-details="row">
                        <b-card>
                          <b-form-group
                            label="مقاله"
                            row.index
                            :class="
                              row.item.uploadedFile.url ? 'done' : 'required'
                            "
                          >
                            <b-form-file
                              :state="Boolean(row.item.file.isUploaded)"
                              :disabled="Boolean(row.item.file.isUploaded)"
                              @input="
                                articleUpload(
                                  articleFiles[row.index],
                                  row.index
                                )
                              "
                              v-model="articleFiles[row.index]"
                              browse-text="بارگذاری"
                              placeholder="فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)"
                            ></b-form-file>
                          </b-form-group>

                          <b-form-group>
                            <b-col>
                              <b-progress
                                v-if="Boolean(row.item.file.uploadPercentage)"
                                :value="row.item.file.uploadPercentage"
                                :max="max"
                                show-progress
                                :animated="row.item.file.striped"
                                :variant="row.item.file.variant"
                              ></b-progress>
                              <!--  -->
                              <br />
                              <b-row>
                                <b-col>
                                  <br />
                                  <div
                                    v-if="row.item.file.isUploaded"
                                    color="green"
                                    class="mt-3"
                                    style="color: green"
                                  >
                                    فایل با موفقیت بارگذاری شد.
                                  </div>
                                </b-col>
                                <b-col>
                                  <b-row align-h="end">
                                    <!-- v-if="row.item.uploadedFile.url" -->
                                    <span class="mt-3 ml-2" style="float: left"
                                      ><a
                                        v-if="row.item.file.isUploaded"
                                        class="btn btn-success"
                                        target="_blank"
                                        >دریافت</a
                                      ></span
                                    >
                                    <!-- :href="row.item.uploadedFile.url" -->

                                    <b-button
                                      v-if="row.item.file.isUploaded"
                                      style="height: 35px; float: left"
                                      class="btn ml-2 mt-3"
                                      variant="danger"
                                      @click="
                                        row.item.uploadedFile = '';
                                        articleFiles[row.index] = null;
                                        row.item.file.uploadPercentage = 0;
                                        row.item.file.isUploaded = false;
                                        row.item.file.showProgress = false;
                                      "
                                      >حذف</b-button
                                    >
                                  </b-row>
                                </b-col>
                              </b-row>
                              <!--  -->
                            </b-col>
                          </b-form-group>
                        </b-card>
                      </template>
                      <template v-slot:cell(operation)="data">
                        <div>
                          <!-- NOTE (b-delService) to remove a row from service items table -->
                          <b-button
                            variant="danger"
                            class="mr-2"
                            @click="delArticle(data.index)"
                          >
                            <i class="fa fa-times" />
                          </b-button>
                        </div>
                      </template>
                      <template v-slot:cell(description)="data">
                        <div>
                          <b-form-input
                            trim
                            v-model="data.item.description"
                            :class="data.item.description ? 'done' : 'required'"
                            type="text"
                          ></b-form-input>
                        </div>
                      </template>
                      <template v-slot:cell(subject)="data">
                        <div>
                          <b-form-input
                            trim
                            v-model="data.item.subject"
                            :class="data.item.subject ? 'done' : 'required'"
                            type="text"
                          ></b-form-input>
                        </div>
                      </template>
                      <template v-slot:cell(releaseYear)="data">
                        <div>
                          <b-form-input
                            trim
                            v-model="data.item.releaseYear"
                            :class="data.item.releaseYear ? 'done' : 'required'"
                            type="text"
                          ></b-form-input>
                        </div>
                      </template>
                      <template v-slot:cell(refrence)="data">
                        <div>
                          <b-form-input
                            trim
                            v-model="data.item.refrence"
                            :class="data.item.refrence ? 'done' : 'required'"
                            type="text"
                          ></b-form-input>
                        </div>
                      </template>
                      <template v-slot:cell(writersName)="data">
                        <div>
                          <b-form-input
                            trim
                            v-model="data.item.writersName"
                            :class="data.item.writersName ? 'done' : 'required'"
                            type="text"
                          ></b-form-input>
                        </div>
                      </template>
                      <template v-slot:cell(magName)="data">
                        <div>
                          <b-form-input
                            trim
                            v-model="data.item.magName"
                            :class="data.item.magName ? 'done' : 'required'"
                            type="text"
                          ></b-form-input>
                        </div>
                      </template>
                    </b-table>
                  </b-form-group>
                </b-card-text>
              </b-card>
            </b-card-body>
          </b-tab>
          <b-tab :title="'اطلاعات اساتید'">
            <b-card-body>
              <b-card header-bg-variant="default" class="border-0 shadow-sm">
                <template v-slot:header>
                  <h4 class="mb-0">استاد راهنمای داخلی</h4>
                </template>

                <b-card-text>
                  <div class="row">
                    <div class="col">
                      <b-form-group
                        label="نام"
                        :class="supervisors[0].name ? 'done' : 'required'"
                      >
                        <b-form-input
                          trim
                          type="text"
                          v-model="supervisors[0].name"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col">
                      <b-form-group
                        label="نام خانوادگی"
                        :class="supervisors[0].lastName ? 'done' : 'required'"
                      >
                        <b-form-input
                          trim
                          type="text"
                          v-model="supervisors[0].lastName"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <b-form-group
                        label="تلفن همراه"
                        :class="supervisors[0].mobile ? 'done' : 'required'"
                      >
                        <b-form-input
                          trim
                          type="number"
                          :no-wheel="true"
                          v-model="supervisors[0].mobile"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col">
                      <b-form-group
                        label="کدملی"
                        :class="
                          isIDClass(supervisors[0].natCode)
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b-form-input
                          trim
                          type="text"
                          v-model="supervisors[0].natCode"
                          aria-describedby="input-1-live-feedback"
                          :state="isID(supervisors[0].natCode)"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback"
                          >کد ملی درست نیست</b-form-invalid-feedback
                        >
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <b-form-group
                        label="پست الکترونیکی"
                        :class="
                          isEmailClass(supervisors[0].email)
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b-form-input
                          trim
                          :state="isEmail(supervisors[0].email)"
                          aria-describedby="input-1-live-feedback"
                          type="text"
                          v-model="supervisors[0].email"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback"
                          >پست الکترونیکی درست نیست</b-form-invalid-feedback
                        >
                      </b-form-group>
                    </div>
                    <div class="col">
                      <b-form-group
                        label="سمت"
                        :class="supervisors[0].position ? 'done' : 'required'"
                      >
                        <b-form-input
                          trim
                          v-model="supervisors[0].position"
                          type="text"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                  </div>

                  <b-form-group
                    label="آخرین مدرک تحصیلی"
                    :class="supervisors[0].lastDegree ? 'done' : 'required'"
                  >
                    <b-form-select
                      :options="lastDegree"
                      v-model="supervisors[0].lastDegree"
                    >
                    </b-form-select>
                  </b-form-group>
                  <b-row class="mb-2">
                    <b-col>
                      <span :class="colleagueUniversityClass"
                        >دانشگاه محل تحصیل</span
                      >
                    </b-col>
                    <b-col class="text-left">
                      <b-form-checkbox
                        id="checkbox-4"
                        v-model="supervisors[0].universityId"
                        name="checkbox-4"
                        :value="notUniversity"
                        unchecked-value=""
                        @change="reactivity = !reactivity"
                      >
                        سایر دانشگاه ها
                      </b-form-checkbox>
                    </b-col>
                  </b-row>

                  <b-form-group>
                    <Select2
                      v-model="supervisors[0].universityId"
                      :options="universities"
                      :settings="{ width: '100%' }"
                      :disabled="supervisors[0].universityId == notUniversity"
                    ></Select2>
                    <b-form-input
                      trim
                      class="mt-1"
                      v-model="supervisors[0].universityOther"
                      v-show="supervisors[0].universityId == notUniversity"
                      placeholder="نام دانشگاه"
                      @input="reactivity = !reactivity"
                    ></b-form-input>
                  </b-form-group>
                  <b-row class="mb-2">
                    <b-col>
                      <span :class="colleagueUniversityJobClass"
                        >دانشگاه محل اشتغال به عنوان عضوهئیت علمی</span
                      >
                    </b-col>
                    <b-col class="text-left">
                      <b-form-checkbox
                        id="checkbox-5"
                        v-model="supervisors[0].universityJobId"
                        name="checkbox-5"
                        :value="notUniversity"
                        unchecked-value=""
                        @change="reactivity = !reactivity"
                      >
                        سایر دانشگاه ها
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                  <b-form-group>
                    <Select2
                      v-model="supervisors[0].universityJobId"
                      :options="universities"
                      :settings="{ width: '100%' }"
                      :disabled="
                        supervisors[0].universityJobId == notUniversity
                      "
                    ></Select2>
                    <b-form-input
                      trim
                      class="mt-1"
                      v-model="supervisors[0].universityJobOther"
                      v-show="supervisors[0].universityJobId == notUniversity"
                      placeholder="نام دانشگاه"
                      @input="reactivity = !reactivity"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="رزومه سوابق علمی، تخصصی و تحقیقاتی"
                    :class="supervisors[0].resumeFile ? 'done' : 'required'"
                  >
                    <b-form-file
                      :state="Boolean(supervisors[0].resumeFile)"
                      :disabled="Boolean(supervisors[0].resumeFile)"
                      @input="supUploadFile(supervisors[0].file)"
                      v-model="supervisors[0].file"
                      browse-text="بارگذاری"
                      :placeholder="
                        supervisors[0].resumeFile
                          ? supervisors[0].resumeFile
                          : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                      "
                    ></b-form-file>
                  </b-form-group>
                  <b-form-group>
                    <b-col>
                      <b-progress
                        v-if="supervisors[0].showProgress"
                        :value="supervisors[0].uploadPercentage"
                        :max="max"
                        show-progress
                        :animated="supervisors[0].striped"
                        :variant="supervisors[0].variant"
                      ></b-progress>
                      <br />
                      <b-row>
                        <b-col>
                          <div
                            style="color: green"
                            v-if="supervisors[0].isUploaded"
                          >
                            فایل جدید با موفقیت آپلود شد.
                          </div>
                        </b-col>
                        <b-col>
                          <b-row align-h="end" v-if="supervisors[0].resumeFile">
                            <span class="mt-3 ml-2" style="float: left"
                              ><a
                                class="btn btn-success"
                                :href="supervisors[0].resumeFile"
                                target="_blank"
                                >دریافت</a
                              ></span
                            >
                            <b-button
                              style="height: 35px; float: left"
                              class="btn ml-2 mt-3"
                              variant="danger"
                              @click="
                                supervisors[0].file = null;
                                supervisors[0].resumeFile = '';
                                supervisors[0].resumeFileId = '';
                                supervisors[0].isUploaded = false;
                                supervisors[0].uploadPercentage = 0;
                              "
                              >حذف</b-button
                            >
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-form-group>

                  <hr />
                </b-card-text>
              </b-card>
              <b-card header-bg-variant="default" class="border-0 shadow-sm">
                <template v-slot:header>
                  <h4 class="mb-0">استاد راهنمای خارجی</h4>
                </template>

                <b-card-text>
                  <div class="row">
                    <div class="col">
                      <b-form-group
                        label="نام"
                        :class="advisors[0].name ? 'done' : 'required'"
                      >
                        <b-form-input
                          trim
                          type="text"
                          v-model="advisors[0].name"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col">
                      <b-form-group
                        label="نام خانوادگی"
                        :class="advisors[0].lastName ? 'done' : 'required'"
                      >
                        <b-form-input
                          trim
                          type="text"
                          v-model="advisors[0].lastName"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <b-form-group
                        label="شماره تماس"
                        :class="advisors[0].mobile ? 'done' : 'required'"
                      >
                        <b-form-input
                          trim
                          type="number"
                          :no-wheel="true"
                          v-model="advisors[0].mobile"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <b-form-group
                        label="پست الکترونیکی"
                        :class="
                          isEmailClass(advisors[0].email) ? 'done' : 'required'
                        "
                      >
                        <b-form-input
                          trim
                          :state="isEmail(advisors[0].email)"
                          aria-describedby="input-1-live-feedback"
                          type="text"
                          v-model="advisors[0].email"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback"
                          >پست الکترونیکی درست نیست</b-form-invalid-feedback
                        >
                      </b-form-group>

                      <b-form-group
                        label="سمت"
                        :class="advisors[0].position ? 'done' : 'required'"
                      >
                        <b-form-input
                          trim
                          v-model="advisors[0].position"
                          type="text"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                  </div>

                  <b-form-group
                    label="دانشگاه محل اشتغال به عنوان عضوهئیت علمی:"
                    :class="
                      advisors[0].universityJobOther ? 'done' : 'required'
                    "
                  >
                    <b-form-input
                      trim
                      v-model="advisors[0].universityJobOther"
                      :options="universities"
                      :settings="{ width: '100%' }"
                    ></b-form-input>
                    <!--<b-form-input
                    trim
                    class="mt-1"
                    v-model="advisors.UniversityJobOther"
                    v-show="advisors.universityJobEn ==notUniversity"
                    placeholder="نام دانشگاه"
                  ></b-form-input>-->
                  </b-form-group>

                  <b-form-group
                    label="دانشگاه محل تحصیل"
                    :class="advisors[0].universityOther ? 'done' : 'required'"
                  >
                    <b-form-input
                      trim
                      v-model="advisors[0].universityOther"
                      :options="universities"
                      :settings="{ width: '100%' }"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="آخرین مدرک تحصیلی"
                    :class="advisors[0].lastDegree ? 'done' : 'required'"
                  >
                    <b-form-select
                      :options="lastDegree"
                      v-model="advisors[0].lastDegree"
                    >
                    </b-form-select>
                  </b-form-group>

                  <!--<b-form-group>
                    <b-col>
                      <b-progress
                        v-if="Boolean(myFile[1].showProgress)"
                        :value="myFile[1].uploadPercentage"
                        :max="max"
                        show-progress
                        :animated="myFile[1].striped"
                        :variant="myFile[1].variant"
                      ></b-progress>
                      <br />
                      <b-row>
                        <b-col>
                          <div style="color: green" v-if="myFile[1].isUploaded">
                            فایل جدید با موفقیت آپلود شد.
                          </div>
                        </b-col>
                        <b-col>
                          <b-row align-h="end">
                            <span class="mt-3 ml-2" style="float: left"
                              ><a
                                class="btn btn-success"
                                v-if="uploadedFiles[1]"
                                :href="uploadedFiles[1].url"
                                target="_blank"
                                >دریافت</a
                              ></span
                            >
                            <b-button
                              style="height: 35px; float: left"
                              class="btn ml-2 mt-3"
                              v-if="uploadedFiles[1]"
                              variant="danger"
                              @click="delFile(1)"
                              >حذف</b-button
                            >
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-form-group>-->

                  <hr />
                </b-card-text>
              </b-card>
            </b-card-body>
          </b-tab>
          <b-tab :title="' اطلاعات تجاری‌سازی'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">اطلاعات تجاری‌سازی</h4>
              </template>
              <v-row
                class="p-1 mb-4 grey lighten-2"
                style="border: 1px solid #ccc; border-radius: 10px"
              >
                <v-col>
                  <p>گزینه مورد نظر را انتخاب کنید:</p>
                  <b-form-radio-group
                    v-model="proposal.commercializingType"
                    class="d-flex justify-space-between"
                  >
                    <b-form-radio value="company" class="ms-1"
                      >شرکت دانش بنیان</b-form-radio
                    >
                    <b-form-radio value="accelerator">شتاب‌دهنده</b-form-radio>
                    <b-form-radio value="none">
                      فاقد اطلاعات تجاری‌سازی هستم</b-form-radio
                    >
                  </b-form-radio-group>
                </v-col>
              </v-row>

              <div v-if="proposal.commercializingType == 'company'">
                <div class="text-left mb-6">
                  <v-btn @click="viewList('company')" class="btn-light"
                    ><span class="fs-xsmall"
                      ><v-icon class="me-1">mdi-table-of-contents</v-icon>مشاهده
                      لیست شرکت‌ها</span
                    ></v-btn
                  >
                </div>
                <v-row class="pb-1">
                  <v-col>
                    <span
                      :class="
                        proposal.companyId
                          ? proposal.companyId != notCompany
                            ? 'done'
                            : proposal.otherCompanyName
                            ? 'done'
                            : 'required'
                          : 'required'
                      "
                    >
                      نام شرکت
                    </span>
                  </v-col>
                  <v-col class="text-left">
                    <b-form-checkbox
                      v-model="proposal.companyId"
                      :value="notCompany"
                      unchecked-value=""
                      @change="reactivity = !reactivity"
                    >
                      سایر شرکت ها
                    </b-form-checkbox>
                  </v-col>
                </v-row>
                <b-form-group>
                  <Select2
                    v-model="proposal.companyId"
                    :options="companies"
                    :settings="{ width: '100%' }"
                    :disabled="proposal.companyId == notCompany"
                    @change="getCompanyInfo()"
                  ></Select2>
                  <b-form-input
                    trim
                    class="mt-1"
                    v-model="proposal.otherCompanyName"
                    v-show="proposal.companyId == notCompany"
                    placeholder="نام شرکت"
                    @input="reactivity = !reactivity"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  label="شماره ثبت شرکت"
                  :class="computedTitle1 ? 'done' : 'required'"
                >
                  <div
                    v-if="
                      proposal.companyId && proposal.companyId != notCompany
                    "
                    class="readonly-box"
                  >
                    <span class="c-grey">{{
                      proposal.companyRegistrationNumber
                        ? proposal.companyRegistrationNumber
                        : "-"
                    }}</span>
                  </div>
                  <b-form-input
                    trim
                    type="text"
                    v-model="proposal.otherCompanyRegistrationNumber"
                    v-else
                    rows="6"
                    max-rows="6"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="شناسه ملی شرکت"
                  :class="computedTitle2 ? 'done' : 'required'"
                >
                  <div
                    v-if="
                      proposal.companyId && proposal.companyId != notCompany
                    "
                    class="readonly-box"
                  >
                    <span class="c-grey">{{
                      proposal.companyNationalId
                        ? proposal.companyNationalId
                        : "-"
                    }}</span>
                  </div>
                  <b-form-input
                    trim
                    type="text"
                    v-model="proposal.otherCompanyNationalId"
                    v-else
                    rows="6"
                    max-rows="6"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="معرفی فناوری یا محصولات شرکت:"
                  :class="proposal.companyProducts ? 'done' : 'required'"
                >
                  <b-form-textarea
                    trim
                    type="text"
                    rows="6"
                    v-model="proposal.companyProducts"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group
                  label="آدرس پستی / شماره تماس/ پست الکترونیک شرکت:"
                  :class="proposal.companyContactInfo ? 'done' : 'required'"
                >
                  <b-form-textarea
                    trim
                    type="text"
                    v-model="proposal.companyContactInfo"
                    rows="6"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group
                  label="توضیحات:"
                  :class="proposal.companyDescription ? 'done' : 'required'"
                >
                  <b-form-textarea
                    trim
                    type="text"
                    v-model="proposal.companyDescription"
                    rows="6"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group
                  :class="proposal.letterCompanyFile ? 'done' : 'required'"
                >
                  <b-row class="my-2" align-v="center">
                    <b-col align-self="end">
                      <h6>نامه شرکت دانش بنیان</h6>
                    </b-col>
                    <b-col>
                      <!-- NOTE (<a>) to download the sample file of university approval by opening a new page -->
                      <a
                        :href="
                          filePath +
                          `/setad/private/1613312877139danesh_bonyan.doc`
                        "
                        class="btn btn-primary text-light"
                        target="_blank"
                        style="float: left"
                        >دانلود نمونه فایل</a
                      >
                    </b-col>
                  </b-row>
                  <b-form-file
                    :state="Boolean(proposal.letterCompanyFile)"
                    :disabled="Boolean(proposal.letterCompanyFile)"
                    @input="
                      uploadFile(
                        uploadedFiles[12].file,
                        12,
                        'letterCompanyFile'
                      )
                    "
                    v-model="uploadedFiles[12].file"
                    browse-text="بارگذاری"
                    :placeholder="
                      files[12]
                        ? files[12].showName
                        : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                    "
                  ></b-form-file>
                </b-form-group>
                <b-form-group>
                  <b-col>
                    <b-progress
                      v-if="uploadedFiles[12].uploadPercentage"
                      :value="uploadedFiles[12].uploadPercentage"
                      :max="max"
                      show-progress
                      :animated="uploadedFiles[12].striped"
                      :variant="uploadedFiles[12].variant"
                    ></b-progress>
                    <br />
                    <b-row>
                      <b-col>
                        <div
                          style="color: green"
                          v-if="uploadedFiles[12].isUploaded"
                        >
                          فایل جدید با موفقیت آپلود شد.
                        </div>
                      </b-col>
                      <b-col>
                        <b-row v-if="proposal.letterCompanyFile" align-h="end">
                          <span class="mt-3 ml-2" style="float: left"
                            ><a
                              class="btn btn-success"
                              :href="proposal.letterCompanyFile"
                              target="_blank"
                              >دریافت</a
                            ></span
                          >
                          <b-button
                            style="height: 35px; float: left"
                            class="btn ml-2 mt-3"
                            variant="danger"
                            @click="delFile(12, 'letterCompanyFile')"
                            >حذف</b-button
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-form-group>
              </div>
              <div
                v-else-if="proposal.commercializingType == 'accelerator'"
                class="mb-4"
              >
                <div class="text-left mb-6">
                  <v-btn @click="viewList('accelerator')" class="btn-light"
                    ><span class="fs-xsmall"
                      ><v-icon class="me-1">mdi-table-of-contents</v-icon>مشاهده
                      لیست شتاب‌دهنده‌ها</span
                    ></v-btn
                  >
                </div>
                <v-row class="pb-1">
                  <v-col>
                    <span :class="proposal.acceleratorId ? 'done' : 'required'"
                      >نام شتاب‌دهنده</span
                    >
                  </v-col>
                </v-row>
                <Select2
                  v-model="proposal.acceleratorId"
                  :options="accelerators"
                  :settings="{ width: '100%' }"
                ></Select2>
                <b-form-group>
                  <b-row class="my-2" align-v="center">
                    <b-col align-self="end">
                      <h6>نامه شرکت دانش بنیان</h6>
                    </b-col>
                    <b-col>
                      <!-- NOTE (<a>) to download the sample file of university approval by opening a new page -->
                      <a
                        :href="
                          filePath +
                          `/setad/private/1613312877139danesh_bonyan.doc`
                        "
                        class="btn btn-primary text-light"
                        target="_blank"
                        style="float: left"
                        >دانلود نمونه فایل</a
                      >
                    </b-col>
                  </b-row>
                  <b-form-file
                    :disabled="Boolean(proposal.letterCompanyFile)"
                    @input="
                      uploadFile(
                        uploadedFiles[12].file,
                        12,
                        'letterCompanyFile'
                      )
                    "
                    v-model="uploadedFiles[12].file"
                    browse-text="بارگذاری"
                    :placeholder="
                      files[12]
                        ? files[12].showName
                        : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                    "
                  ></b-form-file>
                </b-form-group>
                <b-form-group>
                  <b-col>
                    <b-progress
                      v-if="uploadedFiles[12].uploadPercentage"
                      :value="uploadedFiles[12].uploadPercentage"
                      :max="max"
                      show-progress
                      :animated="uploadedFiles[12].striped"
                      :variant="uploadedFiles[12].variant"
                    ></b-progress>
                    <br />
                    <b-row>
                      <b-col>
                        <div
                          style="color: green"
                          v-if="uploadedFiles[12].isUploaded"
                        >
                          فایل جدید با موفقیت آپلود شد.
                        </div>
                      </b-col>
                      <b-col>
                        <b-row v-if="proposal.letterCompanyFile" align-h="end">
                          <span class="mt-3 ml-2" style="float: left"
                            ><a
                              class="btn btn-success"
                              :href="proposal.letterCompanyFile"
                              target="_blank"
                              >دریافت</a
                            ></span
                          >
                          <b-button
                            style="height: 35px; float: left"
                            class="btn ml-2 mt-3"
                            variant="danger"
                            @click="delFile(12, 'letterCompanyFile')"
                            >حذف</b-button
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-form-group>
              </div>
              <div v-else-if="proposal.commercializingType == 'none'">
                <div class="d-flex flex-row mb-2">
                  <b-form-checkbox
                    v-model="proposal.commercializingObligation1"
                    @change="reactivity = !reactivity"
                  ></b-form-checkbox
                  ><span
                    class="ps-2"
                    :class="
                      proposal.commercializingObligation1 ? 'done' : 'required'
                    "
                  >
                    تایید میکنم با انتخاب این گزینه تا قبل از تایید درخواست توسط
                    یکی از شتاب‌دهنده‌ها یا شرکت‌های مجاز، ستاد توسعه زیست
                    فناوری هیچگونه مسئولیتی در قبال درخواست من نخواهد داشت.
                  </span>
                </div>
                <div class="d-flex flex-row mb-2">
                  <b-form-checkbox
                    v-model="proposal.commercializingObligation2"
                    @change="reactivity = !reactivity"
                  ></b-form-checkbox>
                  <span
                    class="ps-2"
                    :class="
                      proposal.commercializingObligation2 ? 'done' : 'required'
                    "
                  >
                    تایید میکنم با انتخاب این گزینه، کلیه اطلاعات شخصی و علمی
                    این درخواست، در اختیار شتاب‌دهنده‌ها و شرکت‌های مجاز قرار
                    خواهد گرفت تا بتوانند با بررسی اطلاعات، درخواست بنده را
                    بررسی و تایید کنند.
                  </span>
                </div>
              </div>
            </b-card>
          </b-tab>

          <b-tab :title="'زمان‌بندی'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">شرح خدمات، زمان‌بندی و فازبندی دوره</h4>
              </template>

              <b-form-group
                :class="proposal.gantData.length ? 'done' : 'required'"
              >
                <!-- NOTE (b-addAchievment) to add achievment to achievment items table -->
                <b-button variant="success" class="mb-3 ml-1" @click="addTime()"
                  >+</b-button
                >

                <!-- NOTE (t-achievmentItems) to show achievment and output of proposal  -->
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="proposal.gantData"
                  :fields="timeFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(operation)="data">
                    <!-- NOTE (b-delAvhievment) to remove a row from achievment items table -->
                    <b-button
                      variant="danger"
                      class="mr-2"
                      @click="removeTime(data.index)"
                      >x</b-button
                    >
                  </template>

                  <template v-slot:cell(dispatchDate)="data">
                    <datePicker
                      color="#7b1fa2"
                      v-model="data.item.dispatchDate"
                    ></datePicker>
                  </template>
                  <template v-slot:cell(duration)="data">
                    <b-form-input
                      trim
                      v-model="data.item.duration"
                      type="number"
                      :no-wheel="true"
                    ></b-form-input>
                  </template>
                  <template v-slot:cell(returnDate)="data">
                    <datePicker
                      color="#7b1fa2"
                      v-model="data.item.returnDate"
                    ></datePicker>
                  </template>
                  <template v-slot:cell(proposalSubject)="data">
                    <b-form-input
                      trim
                      v-model="data.item.proposalSubject"
                      type="text"
                    ></b-form-input>
                  </template>
                </b-table>
              </b-form-group>
            </b-card>
          </b-tab>

          <b-tab :title="'فایل‌های تکمیلی '">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">فایل‌ها</h4>
              </template>

              <b-form-group
                :class="proposal.researcherResumeFile ? 'done' : 'required'"
                label="رزومه متقاضی"
              >
                <b-form-file
                  :state="Boolean(proposal.researcherResumeFile)"
                  :disabled="Boolean(proposal.researcherResumeFile)"
                  @input="
                    uploadFile(uploadedFiles[0].file, 0, 'researcherResumeFile')
                  "
                  v-model="uploadedFiles[0].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[0]
                      ? files[0].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>
              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[0].uploadPercentage"
                    :value="uploadedFiles[0].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[0].striped"
                    :variant="uploadedFiles[0].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[0].isUploaded"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.researcherResumeFile" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success"
                            :href="proposal.researcherResumeFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(0, 'researcherResumeFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group
                :class="proposal.foreignTeacherResumeFile ? 'done' : 'required'"
                label="رزومه استاد خارجی"
              >
                <b-form-file
                  :state="Boolean(proposal.foreignTeacherResumeFile)"
                  :disabled="Boolean(proposal.foreignTeacherResumeFile)"
                  @input="
                    uploadFile(
                      uploadedFiles[1].file,
                      1,
                      'foreignTeacherResumeFile'
                    )
                  "
                  v-model="uploadedFiles[1].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[1]
                      ? files[1].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>
              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[1].uploadPercentage"
                    :value="uploadedFiles[1].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[1].striped"
                    :variant="uploadedFiles[1].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[1].isUploaded"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        v-if="proposal.foreignTeacherResumeFile"
                        align-h="end"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success"
                            :href="proposal.foreignTeacherResumeFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(1, 'foreignTeacherResumeFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group
                :class="proposal.hindexFile ? 'done' : 'required'"
                label=" مستندات شاخص Hindex"
              >
                <b-form-file
                  :state="Boolean(proposal.hindexFile)"
                  :disabled="Boolean(proposal.hindexFile)"
                  @input="uploadFile(uploadedFiles[2].file, 2, 'hindexFile')"
                  v-model="uploadedFiles[2].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[2]
                      ? files[2].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>
              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[2].uploadPercentage"
                    :value="uploadedFiles[2].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[2].striped"
                    :variant="uploadedFiles[2].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[2].isUploaded"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.hindexFile" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success"
                            :href="proposal.hindexFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(2, 'hindexFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group
                :class="proposal.comprehensiveTestFile ? 'done' : 'required'"
                label="مستندات آزمون جامع"
              >
                <b-form-file
                  :state="Boolean(proposal.comprehensiveTestFile)"
                  :disabled="Boolean(proposal.comprehensiveTestFile)"
                  @input="
                    uploadFile(
                      uploadedFiles[3].file,
                      3,
                      'comprehensiveTestFile'
                    )
                  "
                  v-model="uploadedFiles[3].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[3]
                      ? files[3].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>
              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[3].uploadPercentage"
                    :value="uploadedFiles[3].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[3].striped"
                    :variant="uploadedFiles[3].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[3].isUploaded"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        v-if="proposal.comprehensiveTestFile"
                        align-h="end"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success"
                            :href="proposal.comprehensiveTestFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(3, 'comprehensiveTestFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group
                :class="proposal.minutesDefenceFile ? 'done' : 'required'"
                label="صورت جلسه تصویب پروپوزال"
              >
                <b-form-file
                  :state="Boolean(proposal.minutesDefenceFile)"
                  :disabled="Boolean(proposal.minutesDefenceFile)"
                  @input="
                    uploadFile(uploadedFiles[4].file, 4, 'minutesDefenceFile')
                  "
                  v-model="uploadedFiles[4].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[4]
                      ? files[4].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>
              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="Boolean(uploadedFiles[4].uploadPercentage)"
                    :value="uploadedFiles[4].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[4].striped"
                    :variant="uploadedFiles[4].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[4].isUploaded"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.minutesDefenceFile" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success"
                            :href="proposal.minutesDefenceFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(4, 'minutesDefenceFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group
                :class="proposal.proposalWordFile ? 'done' : 'required'"
                label="فایل پروپوزال مصوب"
              >
                <b-form-file
                  :state="Boolean(proposal.proposalWordFile)"
                  :disabled="Boolean(proposal.proposalWordFile)"
                  @input="
                    uploadFile(uploadedFiles[5].file, 5, 'proposalWordFile')
                  "
                  v-model="uploadedFiles[5].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[5]
                      ? files[5].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                  accept=".doc,.docx"
                ></b-form-file>
                <b-row>
                  <i
                    class="fa fa-exclamation-triangle fa-2x text-warning ml-3 mt-2"
                    aria-hidden="true"
                  ></i>
                  <p class="mt-3 ml-2">تذکر: فایل به صورت WORD وارد شود</p>
                </b-row>
              </b-form-group>
              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[5].uploadPercentage"
                    :value="uploadedFiles[5].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[5].striped"
                    :variant="uploadedFiles[5].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[5].isUploaded"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.proposalWordFile" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success"
                            :href="proposal.proposalWordFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(5, 'proposalWordFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group
                :class="
                  proposal.invitationDestinationCountryFile
                    ? 'done'
                    : 'required'
                "
                label="دعوتنامه کشور مقصد"
              >
                <b-form-file
                  :state="Boolean(proposal.invitationDestinationCountryFile)"
                  :disabled="Boolean(proposal.invitationDestinationCountryFile)"
                  @input="
                    uploadFile(
                      uploadedFiles[6].file,
                      6,
                      'invitationDestinationCountryFile'
                    )
                  "
                  v-model="uploadedFiles[6].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[6]
                      ? files[6].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>
              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[6].uploadPercentage"
                    :value="uploadedFiles[6].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[6].striped"
                    :variant="uploadedFiles[6].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[6].isUploaded"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        v-if="proposal.invitationDestinationCountryFile"
                        align-h="end"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success"
                            :href="proposal.invitationDestinationCountryFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="
                            delFile(6, 'invitationDestinationCountryFile')
                          "
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group
                :class="proposal.onWayTicketFile ? 'done' : 'required'"
                label="بلیط رفت"
              >
                <b-form-file
                  :state="Boolean(proposal.onWayTicketFile)"
                  :disabled="Boolean(proposal.onWayTicketFile)"
                  @input="
                    uploadFile(uploadedFiles[7].file, 7, 'onWayTicketFile')
                  "
                  v-model="uploadedFiles[7].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[7]
                      ? files[7].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>
              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[7].uploadPercentage"
                    :value="uploadedFiles[7].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[7].striped"
                    :variant="uploadedFiles[7].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[7].isUploaded"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.onWayTicketFile" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success"
                            :href="proposal.onWayTicketFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(7, 'onWayTicketFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group label="بلیط برگشت">
                <b-form-file
                  @input="
                    uploadFile(uploadedFiles[8].file, 8, 'returnTicketFile')
                  "
                  :disabled="Boolean(proposal.returnTicketFile)"
                  v-model="uploadedFiles[8].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[8]
                      ? files[8].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>
              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[8].uploadPercentage"
                    :value="uploadedFiles[8].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[8].striped"
                    :variant="uploadedFiles[8].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[8].isUploaded"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.returnTicketFile" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success"
                            :href="proposal.returnTicketFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(8, 'returnTicketFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group
                :class="proposal.visaFile ? 'done' : 'required'"
                label="ویزا"
              >
                <b-form-file
                  :state="Boolean(proposal.visaFile)"
                  :disabled="Boolean(proposal.visaFile)"
                  @input="uploadFile(uploadedFiles[9].file, 9, 'visaFile')"
                  v-model="uploadedFiles[9].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[9]
                      ? files[9].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>
              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[9].uploadPercentage"
                    :value="uploadedFiles[9].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[9].striped"
                    :variant="uploadedFiles[9].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[9].isUploaded"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.visaFile" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success"
                            :href="proposal.visaFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(9, 'visaFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group
                :class="
                  proposal.certificateSupervisorFile ? 'done' : 'required'
                "
                label="گواهی استاد راهنما در سربرگ با امضا"
              >
                <b-form-file
                  :state="Boolean(proposal.certificateSupervisorFile)"
                  :disabled="Boolean(proposal.certificateSupervisorFile)"
                  @input="
                    uploadFile(
                      uploadedFiles[10].file,
                      10,
                      'certificateSupervisorFile'
                    )
                  "
                  v-model="uploadedFiles[10].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[10]
                      ? files[10].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>
              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[10].uploadPercentage"
                    :value="uploadedFiles[10].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[10].striped"
                    :variant="uploadedFiles[10].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[10].isUploaded"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        v-if="proposal.certificateSupervisorFile"
                        align-h="end"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success"
                            :href="proposal.certificateSupervisorFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(10, 'certificateSupervisorFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group
                :class="
                  proposal.letterRequestDeputyResearchFile ? 'done' : 'required'
                "
              >
                <b-row class="mb-2">
                  <b-col align-self="end">
                    <h6>نامه درخواست معاونت پژوهش</h6>
                  </b-col>
                  <b-col>
                    <!-- NOTE (<a>) to download the sample file of university approval by opening a new page -->
                    <a
                      :href="
                        filePath +
                        `/setad/private/1613477948623moavenat_pajohesh.doc`
                      "
                      class="btn btn-primary text-light"
                      target="_blank"
                      style="float: left"
                      >دانلود نمونه فایل</a
                    >
                  </b-col>
                </b-row>
                <b-form-file
                  :state="Boolean(proposal.letterRequestDeputyResearchFile)"
                  :disabled="Boolean(proposal.letterRequestDeputyResearchFile)"
                  @input="
                    uploadFile(
                      uploadedFiles[11].file,
                      11,
                      'letterRequestDeputyResearchFile'
                    )
                  "
                  v-model="uploadedFiles[11].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[11]
                      ? files[11].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>
              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[11].uploadPercentage"
                    :value="uploadedFiles[11].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[11].striped"
                    :variant="uploadedFiles[11].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[11].isUploaded"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        v-if="proposal.letterRequestDeputyResearchFile"
                        align-h="end"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success"
                            :href="proposal.letterRequestDeputyResearchFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="
                            delFile(11, 'letterRequestDeputyResearchFile')
                          "
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <h4 style="text-align: center">سایر مدارک</h4>
              <br />

              <b-form-group label="سایر مدارک (1)">
                <b-form-file
                  @input="uploadFile(uploadedFiles[13].file, 13, 'otherFile1')"
                  :disabled="Boolean(proposal.otherFile1)"
                  v-model="uploadedFiles[13].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[13]
                      ? files[13].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>
              <b-row
                ><b-col cols="6">
                  <b-form-group label="عنوان">
                    <b-form-input
                      trim
                      type="text"
                      v-model="proposal.otherFile1Title"
                    ></b-form-input>
                  </b-form-group> </b-col
                ><b-col cols="6">
                  <b-form-group label="توضیحات">
                    <b-form-input
                      trim
                      type="text"
                      v-model="proposal.otherFile1Description"
                    ></b-form-input>
                  </b-form-group> </b-col
              ></b-row>
              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[13].uploadPercentage"
                    :value="uploadedFiles[13].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[13].striped"
                    :variant="uploadedFiles[13].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[13].isUploaded"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.otherFile1" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success"
                            :href="proposal.otherFile1"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(13, 'otherFile1')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group label="سایر (2)">
                <b-form-file
                  @input="uploadFile(uploadedFiles[14].file, 14, 'otherFile2')"
                  :disabled="Boolean(proposal.otherFile2)"
                  v-model="uploadedFiles[14].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[14]
                      ? files[14].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>
              <b-row
                ><b-col cols="6">
                  <b-form-group label="عنوان">
                    <b-form-input
                      trim
                      type="text"
                      v-model="proposal.otherFile2Title"
                    ></b-form-input>
                  </b-form-group> </b-col
                ><b-col cols="6">
                  <b-form-group label="توضیحات">
                    <b-form-input
                      trim
                      type="text"
                      v-model="proposal.otherFile2Description"
                    ></b-form-input>
                  </b-form-group> </b-col
              ></b-row>
              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[14].uploadPercentage"
                    :value="uploadedFiles[14].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[14].striped"
                    :variant="uploadedFiles[14].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[14].isUploaded"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.otherFile2" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success"
                            :href="proposal.otherFile2"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(14, 'otherFile2')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group label="سایر (3)">
                <b-form-file
                  @input="uploadFile(uploadedFiles[15].file, 15, 'otherFile3')"
                  :disabled="Boolean(proposal.otherFile3)"
                  v-model="uploadedFiles[15].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[15]
                      ? files[15].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>
              <b-row
                ><b-col cols="6">
                  <b-form-group label="عنوان">
                    <b-form-input
                      trim
                      type="text"
                      v-model="proposal.otherFile3Title"
                    ></b-form-input>
                  </b-form-group> </b-col
                ><b-col cols="6">
                  <b-form-group label="توضیحات">
                    <b-form-input
                      trim
                      type="text"
                      v-model="proposal.otherFile3Description"
                    ></b-form-input>
                  </b-form-group> </b-col
              ></b-row>
              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[15].uploadPercentage"
                    :value="uploadedFiles[15].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[15].striped"
                    :variant="uploadedFiles[15].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[15].isUploaded"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.otherFile3" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success"
                            :href="proposal.otherFile3"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(15, 'otherFile3')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <!-- NOTE (t-fileFields) to show uploded files and each file is downloadable  -->
              <b-table
                responsive
                show-empty
                head-variant="dark"
                :fields="fileFields"
                :items="files.filter((x) => x && x.url != '')"
                empty-text="فایلی وجود ندارد"
                striped
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>

                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(url)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <!-- NOTE (<a>) to download the user uploaded file by opening a new page -->
                    <a
                      v-if="data.value"
                      class="btn btn-success"
                      :href="data.value"
                      target="_blank"
                      >دریافت فایل</a
                    >
                  </div>
                </template>

                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>
            </b-card>
          </b-tab>
          <b-tab :title="'تعهدات'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">تعهدات</h4>
              </template>

              <b-form-group>
                <b-form-checkbox
                  :class="proposal.promiseArrays[0] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[0]"
                >
                  این دوره در مدت زمان اعلام شده انجام می‌گردد و مسئولیت تاخیر
                  در انجام دوره بر عهده مجری می‌باشد. مدت زمان:
                  {{
                    proposal.gantData.length > 0
                      ? (Math.max(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.returnDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        ) -
                          Math.min(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.dispatchDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          )) /
                          3600 /
                          24 /
                          1000 +
                        " روز"
                      : ""
                  }}
                </b-form-checkbox>
                <!-- <b-form-checkbox
                :class="promises.p2 ? 'done' : 'required'"
                v-model="promises.p2"
              >
                این طرح با بودجه اعلام شده در پروپوزال انجام می‌گردد. هزینه
                انجام:
                {{
                  (
                    parseInt(
                      PersonnelCostItem.length == 0
                        ? 0
                        : PersonnelCostItem.map(
                            x =>
                              parseInt(x.perPersonCost) *
                              parseInt(x.cooperationHour)
                          ).reduce((a, b) => parseInt(a) + parseInt(b), 0)
                    ) +
                    parseInt(
                      tripCostItem.length == 0
                        ? 0
                        : tripCostItem
                            .map(x => x.cost)
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                    ) +
                    parseInt(
                      otherCostItem.length == 0
                        ? 0
                        : otherCostItem
                            .map(x => x.totalPrice)
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                    ) +
                    parseInt(
                      OrgCostItem.length == 0
                        ? 0
                        : OrgCostItem.map(x => x.totalPrice).reduce(
                            (a, b) => parseInt(a) + parseInt(b),
                            0
                          )
                    ) +
                    parseInt(
                      deviceCostItem.length == 0
                        ? 0
                        : deviceCostItem
                            .map(x => x.totalPrice)
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                    )
                  ).toLocaleString()
                }}
                ریال
              </b-form-checkbox> -->
                <b-form-checkbox
                  :class="proposal.promiseArrays[2] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[2]"
                  >توافق بین دانشگاه و صنعت در خصوص دستاوردهای دوره وجود
                  دارد.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[3] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[3]"
                  >کلیه اصلاحات در موعد مقرر و طی 2 هفته توسط اینجانب انجام و در
                  سایت بارگذاری می‌گردد.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[4] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[4]"
                  >دستاوردهای دوره مشخص است و مستندات ارائه شده
                  است.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[5] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[5]"
                >
                  بهره‌بردار نهایی دستاوردهای دوره مشخص است و مستندات ارائه شده
                  است.
                  <span v-if="proposal.commercializingType != 'none'">
                    نام بهره‌بردار:
                    <span v-if="proposal.commercializingType == 'company'">{{
                      proposal.companyId == notCompany
                        ? proposal.otherCompanyName
                        : proposal.companyName
                    }}</span>
                    <span v-else>{{
                      proposal.acceleratorId
                        ? accelerators.filter(
                            (x) => x.id == proposal.acceleratorId
                          )[0].text
                        : ""
                    }}</span>
                  </span>
                </b-form-checkbox>
                <b-form-checkbox
                  :class="proposal.promiseArrays[6] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[6]"
                  >کلیه گزارش‌ها و خروجی‌ها و دستاوردها در پایان دوره به ستاد
                  زیست فناوری ارسال و تحویل داده می‌شود.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[7] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[7]"
                  >ثبت اطلاعات در سامانه هیچ تعهدی را برای ستاد ایجاد نمی‌کند و
                  به منزله ثبت درخواست متقاضی است.</b-form-checkbox
                >

                <b-form-checkbox
                  :class="proposal.promiseArrays[8] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[8]"
                  >پروپوزال رساله دکتری اینجانب مصوب شده است.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[9] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[9]"
                  >امتحان جامع با موفقیت سپری شده است</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[10] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[10]"
                >
                  میزان شاخص (Hindex) اینجانب صحت دارد</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[11] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[11]"
                  >دعوتنامه معتبر از کشور مقصد دریافت شده است.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[12] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[12]"
                  >کلیه موارد فوق مورد تایید اینجانب
                  {{
                    (proposal.researcherName ? proposal.researcherName : "-") +
                    " " +
                    proposal.researcherLastName
                  }}
                  به عنوان متقاضی و اساتید راهنما می‌باشد.</b-form-checkbox
                >
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="'مرور نهایی و ارسال'">
            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 border-0"
                role="tab"
              >
                <b-button block v-b-toggle.accordion-1 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    عنوان و حمایت‌های پیشین&nbsp;
                  </h5>

                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 0"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-1"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul class="p-2">
                      <li :class="proposal.faSubject ? 'done' : 'required'">
                        <b>عنوان دقیق دوره:</b> {{ proposal.faSubject }}
                      </li>
                      <li class="done">
                        <b
                          >آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها
                          استفاده کرده است؟</b
                        >
                        <b-form-radio-group
                          v-model="proposal.initialIsSupported"
                          disabled
                        >
                          <b-form-radio :value="true">بله</b-form-radio>
                          <b-form-radio :value="false">خیر</b-form-radio>
                        </b-form-radio-group>
                      </li>

                      <li
                        v-if="
                          proposal.initialIsSupported &&
                          proposal.initialSupportedType
                        "
                        :class="
                          proposal.initialSupportedType ? 'done' : 'required'
                        "
                      >
                        <b>حمایت ها:</b>
                        {{
                          proposal.initialSupportedType
                            ? options.filter(
                                (x) => x.value == proposal.initialSupportedType
                              )[0].text
                            : ""
                        }}
                      </li>
                      <li
                        v-if="
                          proposal.initialSupportedType == 'other' &&
                          proposal.initialIsSupported
                        "
                        :class="
                          proposal.initialOtherSupport ? 'done' : 'required'
                        "
                      >
                        <b> عنوان حمایت دریافتی:</b>
                        {{ proposal.initialOtherSupport }}
                      </li>
                      <li
                        v-if="proposal.initialIsSupported"
                        :class="
                          proposal.initialSupportDescription
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>توضیحات حمایت دریافتی:</b>
                        {{ proposal.initialSupportDescription }}
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 border-0"
                role="tab"
              >
                <b-button block v-b-toggle.accordion-2 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    اطلاعات دوره
                  </h5>

                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 1"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-2"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul class="p-2">
                      <li :class="proposal.faSubject ? 'done' : 'required'">
                        <b>عنوان به زبان فارسی:</b> {{ proposal.faSubject }}
                      </li>
                      <li :class="proposal.enSubject ? 'done' : 'required'">
                        <b>عنوان به زبان انگلیسی:</b> {{ proposal.enSubject }}
                      </li>
                      <li :class="proposal.universityId ? 'done' : 'required'">
                        <b> دانشگاه محل اجرای دوره:</b>
                        {{
                          proposal.universityId
                            ? universities.filter(
                                (x) => x.id == proposal.universityId
                              )[0].text
                            : "-"
                        }}
                      </li>
                      <li
                        v-if="proposal.universityId == notUniversity"
                        :class="proposal.otherUniversity ? 'done' : 'required'"
                      >
                        <b>نام دانشگاه:</b> {{ proposal.otherUniversity }}
                      </li>
                      <li
                        v-if="proposal.mehvarId != notMehvar && mehvars.length"
                        :class="proposal.mehvarId ? 'done' : 'required'"
                      >
                        <b>محور دوره:</b>
                        {{
                          proposal.mehvarId
                            ? mehvars.filter(
                                (x) => x.id == proposal.mehvarId
                              )[0].text
                            : ""
                        }}
                      </li>
                      <li
                        v-if="proposal.mehvarId == notMehvar"
                        :class="proposal.mehvarId ? 'done' : 'required'"
                      >
                        <b>محور دوره:</b> سایر محورها
                      </li>
                      <li
                        v-if="proposal.mehvarId == notMehvar"
                        :class="proposal.otherMehvars ? 'done' : 'required'"
                      >
                        <b>نام محور:</b> {{ proposal.otherMehvars }}
                      </li>
                      <li
                        :class="
                          proposal.typeStudy ||
                          proposal.typeSystemicDevelopmental ||
                          proposal.typePractical
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>ماهیت دوره:</b>
                        <b-form-group
                          disabled
                          :class="
                            proposal.typeStudy ||
                            proposal.typeSystemicDevelopmental ||
                            proposal.typePractical
                              ? 'done'
                              : 'required'
                          "
                        >
                          <b-form-checkbox v-model="proposal.typeStudy"
                            >مطالعاتی</b-form-checkbox
                          >
                          <b-form-checkbox
                            v-model="proposal.typeSystemicDevelopmental"
                            >سیستمی و توسعه‌ای</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.typePractical"
                            >کاربردی</b-form-checkbox
                          >
                        </b-form-group>
                      </li>
                      <li
                        :class="
                          proposal.zoneMedicine ||
                          proposal.zoneAgriculture ||
                          proposal.zoneEnvironment ||
                          proposal.zoneIndustrial ||
                          proposal.zoneBioComputing ||
                          proposal.zoneOther
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>حوزه دوره:</b>
                        <b-form-group disabled>
                          <b-form-checkbox v-model="proposal.zoneMedicine"
                            >پزشکی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneAgriculture"
                            >کشاورزی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneEnvironment"
                            >محیط زیست</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneIndustrial"
                            >صنعتی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneBioComputing"
                            >رایانش زیستی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneOther"
                            >سایر</b-form-checkbox
                          >
                        </b-form-group>
                      </li>
                      <li
                        :class="
                          proposal.oppurtunityActions ? 'done' : 'required'
                        "
                      >
                        <b
                          >گزارش خلاصه اقداماتی که قصد دارید در دانشگاه مقصد در
                          طی دوره انجام دهید:</b
                        >
                        {{ proposal.oppurtunityActions }}
                      </li>
                      <br />
                      <b-table
                        responsive
                        small
                        show-empty
                        head-variant="dark"
                        :items="proposal.oppurtunityAchievements"
                        :fields="achievmentFields"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.index + 1 }}
                          </div>
                        </template>
                      </b-table>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-3 variant="light">
                  <h5 class="mb-0" style="display: inline-block">
                    اطلاعات متقاضی
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 2"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-3"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul class="p-2">
                      <li
                        :class="proposal.researcherName ? 'done' : 'required'"
                      >
                        <b>نام:</b> {{ proposal.researcherName }}
                      </li>
                      <li
                        :class="
                          proposal.researcherLastName ? 'done' : 'required'
                        "
                      >
                        <b>نام خانوادگی:</b> {{ proposal.researcherLastName }}
                      </li>
                      <li
                        :class="
                          proposal.researcherNatCode ? 'done' : 'required'
                        "
                      >
                        <b> کدملی:</b>{{ proposal.researcherNatCode }}
                      </li>
                      <li
                        :class="proposal.researcherMobile ? 'done' : 'required'"
                      >
                        <b>تلفن همراه:</b> {{ proposal.researcherMobile }}
                      </li>
                      <li :class="proposal.researcherFax ? 'done' : 'required'">
                        <b>دورنگار:</b> {{ proposal.researcherFax }}
                      </li>
                      <li
                        :class="proposal.researcherEmail ? 'done' : 'required'"
                      >
                        <b> پست الکترونیکی:</b> {{ proposal.researcherEmail }}
                      </li>
                      <li
                        :class="
                          proposal.researcherStateId ? 'done' : 'required'
                        "
                      >
                        <b>استان:</b>
                        {{
                          proposal.researcherState
                            ? proposal.researcherState
                            : "-"
                        }}
                      </li>
                      <li
                        :class="proposal.researcherCityId ? 'done' : 'required'"
                      >
                        <b>شهر:</b>
                        {{
                          proposal.researcherCity
                            ? proposal.researcherCity
                            : "-"
                        }}
                      </li>
                      <li
                        :class="
                          proposal.researcherUniversityId ? 'done' : 'required'
                        "
                      >
                        <b>دانشگاه محل تحصیل:</b>
                        {{
                          universities.filter(
                            (x) => x.id == proposal.researcherUniversityId
                          ).length
                            ? universities.filter(
                                (x) => x.id == proposal.researcherUniversityId
                              )[0].text
                            : "---"
                        }}
                      </li>
                      <li
                        v-if="proposal.researcherUniversityId == notUniversity"
                        :class="
                          proposal.researcherUniversityOther
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>نام دانشگاه:</b> {{ otherUniHelp }}
                      </li>
                      <li :class="universityJobClass">
                        <b>دانشگاه محل اشتغال:</b>
                        {{
                          proposal.researcherUniversityJobId
                            ? universities.filter(
                                (x) =>
                                  x.id == proposal.researcherUniversityJobId
                              )[0].text
                            : "-"
                        }}
                      </li>
                      <li
                        v-if="
                          proposal.researcherUniversityJobId == notUniversity
                        "
                        :class="
                          proposal.researcherUniversityJobId
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>نام دانشگاه:</b>
                        {{ proposal.researcherUniversityJobOther }}
                      </li>
                      <li
                        :class="proposal.researcherIBAN ? 'done' : 'required'"
                      >
                        <b>شماره شبا:</b> {{ proposal.researcherIBAN }}
                      </li>
                      <li
                        :class="
                          proposal.researcherBankName ? 'done' : 'required'
                        "
                      >
                        <b> نام بانک:</b> {{ proposal.researcherBankName }}
                      </li>
                      <li
                        :class="
                          proposal.researcherUniversityDestination
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>دانشگاه مقصد:</b>
                        {{ proposal.researcherUniversityDestination }}
                      </li>
                      <li
                        :class="
                          proposal.researcherCountryDestination
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>کشور مقصد:</b>
                        {{ proposal.researcherCountryDestination }}
                      </li>
                      <li v-if="proposal.researcherMasterStudent == 'master'">
                        <b>شاخص Hindex استاد:</b>
                        {{ proposal.researcherHindex }}
                      </li>
                      <li v-if="proposal.researcherMasterStudent == 'student'">
                        <b>شاخص Hindex دانشجو:</b>
                        {{ proposal.researcherHindex }}
                      </li>
                      <li v-if="proposal.researcherMasterStudent == 'student'">
                        <b>نمره امتحان جامع دانشجو:</b>
                        {{ proposal.researcherComprehensiveTestMark }}
                      </li>
                      <li v-if="proposal.researcherMasterStudent == 'student'">
                        <b>تاریخ امتحان جامع دانشجو:</b>
                        {{ proposal.researcherComprehensiveTestDate }}
                      </li>
                      <li
                        :class="
                          proposal.researcherPhDThesisSubject
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>عنوان طرح رساله دکتری:</b>
                        {{ proposal.researcherPhDThesisSubject }}
                      </li>
                      <li
                        v-if="proposal.researcherMasterStudent == 'student'"
                        :class="
                          proposal.researcherPhDThesisDefenceDate
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>تاریخ تصویب رساله:</b>
                        {{ proposal.researcherPhDThesisDefenceDate }}
                      </li>
                      <br />
                      <b-table
                        v-if="proposal.researcherArticleISI.length"
                        responsive
                        small
                        show-empty
                        striped
                        head-variant="dark"
                        :items="proposal.researcherArticleISI"
                        :fields="articlesFields"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.index + 1 }}
                          </div>
                        </template>
                        <template v-slot:cell(upload)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            <a
                              v-if="data.item.file.isUploaded"
                              class="btn btn-success"
                              target="_blank"
                              :href="data.item.uploadedFile.url"
                            >
                              دانلود
                            </a>
                            <p v-else>فایل آپلود نشده است</p>
                          </div>
                        </template>
                      </b-table>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-4 variant="warning">
                  <h5 class="mb-0" style="display: inline-block">
                    اطلاعات اساتید
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 3"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-4"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <p>استاد راهنمای داخلی</p>
                    <ul class="p-2">
                      <li :class="supervisors[0].name ? 'done' : 'required'">
                        <b>نام:</b> {{ supervisors[0].name }}
                      </li>
                      <li
                        :class="supervisors[0].lastName ? 'done' : 'required'"
                      >
                        <b>نام خانوادگی:</b> {{ supervisors[0].lastName }}
                      </li>
                      <li :class="supervisors[0].natCode ? 'done' : 'required'">
                        <b>کدملی:</b>{{ supervisors[0].natCode }}
                      </li>
                      <li :class="supervisors[0].mobile ? 'done' : 'required'">
                        <b>تلفن همراه:</b> {{ supervisors[0].mobile }}
                      </li>

                      <li :class="supervisors[0].email ? 'done' : 'required'">
                        <b>پست الکترونیکی:</b> {{ supervisors[0].email }}
                      </li>
                      <li
                        :class="supervisors[0].position ? 'done' : 'required'"
                      >
                        <b>سمت:</b> {{ supervisors[0].position }}
                      </li>
                      <li
                        :class="
                          supervisors[0].universityId ? 'done' : 'required'
                        "
                      >
                        <b>دانشگاه محل تحصیل:</b>
                        {{
                          supervisors[0].universityId
                            ? universities.filter(
                                (x) => x.id == supervisors[0].universityId
                              )[0].text
                            : "-"
                        }}
                      </li>
                      <li
                        v-if="supervisors[0].universityId == notUniversity"
                        :class="
                          supervisors[0].universityOther ? 'done' : 'required'
                        "
                      >
                        <b>نام دانشگاه:</b> {{ supervisors[0].universityOther }}
                      </li>
                      <li
                        :class="
                          supervisors[0].universityJobId ? 'done' : 'required'
                        "
                      >
                        <b>دانشگاه محل اشتغال:</b>
                        {{
                          supervisors[0].universityJobId
                            ? universities.filter(
                                (x) => x.id == supervisors[0].universityJobId
                              )[0].text
                            : "-"
                        }}
                      </li>
                      <li
                        v-if="supervisors[0].universityJobId == notUniversity"
                        :class="
                          supervisors[0].universityJobOther
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>نام دانشگاه:</b>
                        {{ supervisors[0].universityJobOther }}
                      </li>
                      <hr />
                      <p>استاد راهنمای خارجی</p>
                      <li :class="advisors[0].name ? 'done' : 'required'">
                        <b>نام:</b> {{ advisors[0].name }}
                      </li>
                      <li :class="advisors[0].lastName ? 'done' : 'required'">
                        <b>نام خانوادگی:</b> {{ advisors[0].lastName }}
                      </li>
                      <li :class="advisors[0].mobile ? 'done' : 'required'">
                        <b>تلفن همراه:</b> {{ advisors[0].mobile }}
                      </li>

                      <li :class="advisors[0].email ? 'done' : 'required'">
                        <b>پست الکترونیکی:</b> {{ advisors[0].email }}
                      </li>
                      <li :class="advisors[0].position ? 'done' : 'required'">
                        <b> سمت:</b> {{ advisors[0].position }}
                      </li>
                      <li
                        :class="
                          advisors[0].universityOther ? 'done' : 'required'
                        "
                      >
                        <b>دانشگاه محل تحصیل:</b>
                        {{ advisors[0].universityOther }}
                      </li>
                      <li :class="advisors[0].lastDegree ? 'done' : 'required'">
                        <b>آخرین مدرک تحصیلی:</b>
                        {{ advisors[0].lastDegree }}
                      </li>
                      <li
                        :class="
                          advisors[0].universityJobOther ? 'done' : 'required'
                        "
                      >
                        <b>دانشگاه محل اشتغال:</b>
                        {{ advisors[0].universityJobOther }}
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-5 variant="info">
                  <h5 class="mb-0 text-white" style="display: inline-block">
                    اطلاعات تجاری‌سازی
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 4"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-5"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="p-3 shadow">
                    <h4 class="mb-6">
                      نوع تجاری‌سازی:
                      {{
                        proposal.commercializingType == "company"
                          ? "شرکت دانش بنیان"
                          : proposal.commercializingType == "accelerator"
                          ? "شتاب‌دهنده"
                          : "فاقد اطلاعات تجاری‌سازی می‌باشد"
                      }}
                    </h4>
                    <ul
                      class="p-2"
                      v-if="proposal.commercializingType == 'company'"
                    >
                      <li
                        v-if="proposal.companyId == notCompany"
                        :class="proposal.otherCompanyName ? 'done' : 'required'"
                      >
                        <b>نام شرکت دانش بنیان:</b>
                        {{ proposal.otherCompanyName }}
                      </li>
                      <li
                        v-else
                        :class="proposal.companyName ? 'done' : 'required'"
                      >
                        <b>نام شرکت دانش بنیان:</b> {{ proposal.companyName }}
                      </li>
                      <li
                        v-if="proposal.companyId == notCompany"
                        :class="
                          proposal.otherCompanyRegistrationNumber
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b> شماره ثبت شرکت:</b>
                        {{ proposal.otherCompanyRegistrationNumber }}
                      </li>
                      <li
                        v-else
                        :class="proposal.companyName ? 'done' : 'required'"
                      >
                        <b>شماره ثبت شرکت:</b>
                        {{
                          proposal.companyRegistrationNumber
                            ? proposal.companyRegistrationNumber
                            : "-"
                        }}
                      </li>
                      <li
                        v-if="proposal.companyId == notCompany"
                        :class="
                          proposal.otherCompanyNationalId ? 'done' : 'required'
                        "
                      >
                        <b>شناسه ملی شرکت:</b>
                        {{ proposal.otherCompanyNationalId }}
                      </li>
                      <li
                        v-else
                        :class="proposal.companyName ? 'done' : 'required'"
                      >
                        <b> شناسه ملی شرکت:</b>
                        {{
                          proposal.companyNationalId
                            ? proposal.companyNationalId
                            : "-"
                        }}
                      </li>
                      <li
                        :class="proposal.companyProducts ? 'done' : 'required'"
                      >
                        <b>معرفی فناوری یا محصولات شرکت:</b>
                        {{ proposal.companyProducts }}
                      </li>
                      <li
                        :class="
                          proposal.companyContactInfo ? 'done' : 'required'
                        "
                      >
                        <b>آدرس پستی / شماره تماس/ پست الکترونیک شرکت:</b>
                        {{ proposal.companyContactInfo }}
                      </li>
                      <li
                        :class="
                          proposal.companyDescription ? 'done' : 'required'
                        "
                      >
                        <b>توضیحات:</b> {{ proposal.companyDescription }}
                      </li>
                    </ul>
                    <div
                      v-if="proposal.commercializingType == 'accelerator'"
                      :class="proposal.acceleratorId ? 'done' : 'required'"
                    >
                      <b> نام شتاب‌دهنده:</b>
                      {{
                        proposal.acceleratorId
                          ? accelerators.filter(
                              (x) => x.id == proposal.acceleratorId
                            )[0].text
                          : ""
                      }}
                    </div>
                    <ul v-if="proposal.commercializingType == 'none'">
                      <li
                        class="mb-4 d-flex flex-row"
                        :class="
                          proposal.commercializingObligation1
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b-form-checkbox
                          v-model="proposal.commercializingObligation1"
                          disabled
                          class="me-4"
                        ></b-form-checkbox>
                        تایید میکنم با انتخاب این گزینه تا قبل از تایید درخواست
                        توسط یکی از شتاب‌دهنده‌ها یا شرکت‌های مجاز، ستاد توسعه
                        زیست فناوری هیچگونه مسئولیتی در قبال درخواست من نخواهد
                        داشت.
                      </li>
                      <li
                        class="d-flex flex-row"
                        :class="
                          proposal.commercializingObligation2
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b-form-checkbox
                          v-model="proposal.commercializingObligation2"
                          disabled
                          class="me-4"
                        ></b-form-checkbox>
                        تایید میکنم با انتخاب این گزینه، کلیه اطلاعات شخصی و
                        علمی این درخواست، در اختیار شتاب‌دهنده‌ها و شرکت‌های
                        مجاز قرار خواهد گرفت تا بتوانند با بررسی اطلاعات،
                        درخواست بنده را بررسی و تایید کنند.
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-6 variant="info">
                  <h5 class="mb-0 text-white" style="display: inline-block">
                    زمان‌بندی دوره
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 5"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-6"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="proposal.gantData"
                      :fields="timeFields"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-7 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    فایل‌های تکمیلی
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 6"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-7"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <h5>
                      در این جدول کلیه فایل‌های رساله را مشاهده میفرمایید.
                    </h5>
                    <b-table
                      responsive
                      show-empty
                      head-variant="dark"
                      :fields="fileFields"
                      :items="files.filter((x) => x && x.url != '')"
                      empty-text="فایلی وجود ندارد"
                      striped
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>

                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(url)="data">
                        <div style="text-align: center; vertical-align: middle">
                          <!-- NOTE (<a>) to download the user uploaded file by opening a new page -->
                          <a
                            v-if="data.value"
                            class="btn btn-success"
                            :href="data.value"
                            target="_blank"
                            >دریافت فایل</a
                          >
                        </div>
                      </template>

                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                      <div
                        slot="table-busy"
                        class="text-center text-danger my-2"
                      >
                        <strong>در حال بارگذاری...</strong>
                        <br />
                        <b-spinner class="align-middle"></b-spinner>
                      </div>
                    </b-table>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-8 variant="warning">
                  <h5 class="mb-0" style="display: inline-block">
                    تعهدات&nbsp;
                  </h5>

                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 6"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-8"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="p-3 shadow">
                    <b-form-group disabled>
                      <b-form-checkbox
                        :class="proposal.promiseArrays[0] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[0]"
                      >
                        این دوره در مدت زمان اعلام شده انجام می‌گردد و مسئولیت
                        تاخیر در انجام دوره بر عهده مجری می‌باشد. مدت زمان:
                        {{
                          proposal.gantData.length > 0
                            ? (Math.max(
                                ...proposal.gantData.map((x) =>
                                  new Date(
                                    moment(
                                      x.returnDate,
                                      "jYYYY/jMM/jDD"
                                    ).format("YYYY-MM-DD")
                                  ).getTime()
                                )
                              ) -
                                Math.min(
                                  ...proposal.gantData.map((x) =>
                                    new Date(
                                      moment(
                                        x.dispatchDate,
                                        "jYYYY/jMM/jDD"
                                      ).format("YYYY-MM-DD")
                                    ).getTime()
                                  )
                                )) /
                                3600 /
                                24 /
                                1000 +
                              " روز"
                            : ""
                        }}
                      </b-form-checkbox>
                      <!-- <b-form-checkbox
                :class="promises.p2 ? 'done' : 'required'"
                v-model="promises.p2"
              >
                این طرح با بودجه اعلام شده در پروپوزال انجام می‌گردد. هزینه
                انجام:
                {{
                  (
                    parseInt(
                      PersonnelCostItem.length == 0
                        ? 0
                        : PersonnelCostItem.map(
                            x =>
                              parseInt(x.perPersonCost) *
                              parseInt(x.cooperationHour)
                          ).reduce((a, b) => parseInt(a) + parseInt(b), 0)
                    ) +
                    parseInt(
                      tripCostItem.length == 0
                        ? 0
                        : tripCostItem
                            .map(x => x.cost)
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                    ) +
                    parseInt(
                      otherCostItem.length == 0
                        ? 0
                        : otherCostItem
                            .map(x => x.totalPrice)
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                    ) +
                    parseInt(
                      OrgCostItem.length == 0
                        ? 0
                        : OrgCostItem.map(x => x.totalPrice).reduce(
                            (a, b) => parseInt(a) + parseInt(b),
                            0
                          )
                    ) +
                    parseInt(
                      deviceCostItem.length == 0
                        ? 0
                        : deviceCostItem
                            .map(x => x.totalPrice)
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                    )
                  ).toLocaleString()
                }}
                ریال
              </b-form-checkbox> -->
                      <b-form-checkbox
                        :class="proposal.promiseArrays[2] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[2]"
                        >توافق بین دانشگاه و صنعت در خصوص دستاوردهای دوره وجود
                        دارد.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[3] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[3]"
                        >کلیه اصلاحات در موعد مقرر و طی 2 هفته توسط اینجانب
                        انجام و در سایت بارگذاری می‌گردد.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[4] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[4]"
                        >دستاوردهای دوره مشخص است و مستندات ارائه شده
                        است.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[5] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[5]"
                      >
                        بهره‌بردار نهایی دستاوردهای دوره مشخص است و مستندات
                        ارائه شده است.
                        <span v-if="proposal.commercializingType != 'none'">
                          نام بهره‌بردار:
                          <span
                            v-if="proposal.commercializingType == 'company'"
                            >{{
                              proposal.companyId == notCompany
                                ? proposal.otherCompanyName
                                : proposal.companyName
                            }}</span
                          >
                          <span v-else>{{
                            proposal.acceleratorId
                              ? accelerators.filter(
                                  (x) => x.id == proposal.acceleratorId
                                )[0].text
                              : ""
                          }}</span>
                        </span>
                      </b-form-checkbox>
                      <b-form-checkbox
                        :class="proposal.promiseArrays[6] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[6]"
                        >کلیه گزارش‌ها و خروجی‌ها و دستاوردها در پایان دوره به
                        ستاد زیست فناوری ارسال و تحویل داده
                        می‌شود.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[7] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[7]"
                        >ثبت اطلاعات در سامانه هیچ تعهدی را برای ستاد ایجاد
                        نمی‌کند و به منزله ثبت درخواست متقاضی
                        است.</b-form-checkbox
                      >

                      <b-form-checkbox
                        :class="proposal.promiseArrays[8] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[8]"
                        >پروپوزال رساله دکتری اینجانب مصوب شده
                        است.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[9] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[9]"
                        >امتحان جامع با موفقیت سپری شده است</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="
                          proposal.promiseArrays[10] ? 'done' : 'required'
                        "
                        v-model="proposal.promiseArrays[10]"
                      >
                        میزان شاخص (Hindex) اینجانب صحت دارد</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="
                          proposal.promiseArrays[11] ? 'done' : 'required'
                        "
                        v-model="proposal.promiseArrays[11]"
                        >دعوتنامه معتبر از کشور مقصد دریافت شده
                        است.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="
                          proposal.promiseArrays[12] ? 'done' : 'required'
                        "
                        v-model="proposal.promiseArrays[12]"
                        >کلیه موارد فوق مورد تایید اینجانب
                        {{
                          (proposal.researcherName
                            ? proposal.researcherName
                            : "-") +
                          " " +
                          (proposal.researcherLastName
                            ? proposal.researcherLastName
                            : "")
                        }}
                        به عنوان متقاضی و اساتید راهنما
                        می‌باشد.</b-form-checkbox
                      >
                    </b-form-group>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-button
              class="m-2"
              variant="success"
              :disabled="sending"
              @click="submit()"
              >ارسال</b-button
            >
          </b-tab>
        </b-tabs>
        <div class="d-flex justify-content-center mt-3">
          <!-- NOTE (b-previousPage-2) previous -->
          <b-button
            v-if="tabIndex != 0"
            class="mx-1"
            variant="light"
            @click="changePage('back')"
            >مرحله قبل</b-button
          >

          <!-- NOTE (b-nextPage-2) previous -->
          <b-button
            v-if="tabIndex != 8"
            class="mx-1"
            variant="primary"
            @click="changePage('next')"
            >مرحله بعد</b-button
          >
        </div>
      </b-card>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import router from "../../router"; // NOTE (IMPORT) to communication between different parts of the site
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
import GSTC from "vue-gantt-schedule-timeline-calendar";
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time
const sarmadGantt = () => import("../../components/sarmadGantt");
import { Compact } from "vue-color"; // REVIEW
import ColourPicker from "vue-colour-picker"; // REVIEW
import mixin from "../../mixins/utilities";

export default {
  mixins: [mixin],
  components: {
    Select2, // NOTE (COMPONENT) component of select2 plugin
    GSTC,
    datePicker: VuePersianDatetimePicker, // NOTE (COMPONENT) component of VuePersianDatetimePicker plugin
    sarmadGantt: sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
    compact: Compact,
    ColourPicker,
  },
  data() {
    return {
      articleFiles: [],
      reactivity: false,
      reactivity2: false,
      sending: false,
      otherUniHelp: "",
      otherUniJobHelp: "",
      universityJobHelp: "",
      isSaving: false,
      infoo: "",
      promises: {},
      eduGradeOptions: [
        { text: "--مقطع را انتخاب کنید", disabled: true },
        "کارشناسی",
        "کارشناسی ارشد",
        "دکتری",
        "دکتری حرفه ای",
      ],

      moment: moment,
      ckeckbox: {},
      show: false,
      busy: false,
      initial: {},
      doi: "",
      code: {},
      source: "",
      specs: {},
      colleaguesData: [],
      serviceItems: [],
      selectedColleague: "",
      executor: {},
      researchers: [],
      proposal: {
        initialIsSupported: null,
        commercializingType: "company",
        gantData: [],
        researcherArticleISI: [],
        oppurtunityAchievements: [],
        promiseArrays: [],
        researcherId: 0,
        obligations: [],
        researcherResumeFile: "",
        foreignTeacherResumeFile: "",
        hindexFile: "",
        comprehensiveTestFile: "",
        minutesDefenceFile: "",
        proposalWordFile: "",
        invitationDestinationCountryFile: "",
        onWayTicketFile: "",
        returnTicketFile: "",
        visaFile: "",
        certificateSupervisorFile: "",
        letterRequestDeputyResearchFile: "",
        letterCompanyFile: "",
        otherFile1: "",
        otherFile2: "",
        otherFile3: "",
      },
      sponsorType: null,
      accelerators: [],
      sending: false,
      colleague: {},
      universities: [],
      companies: [],
      iran: [],
      otherUniversity: "",
      mehvars: [],
      otherMehvars: "",
      zone: new Array(6).fill(false),
      tabIndex: 1,
      timeitems: [],
      pageLoaded: false,
      timeFields: [
        { key: "index", label: "ردیف" },
        { key: "dispatchDate", label: "تاریخ اعزام" },
        { key: "duration", label: "مدت زمان دوره" },
        { key: "returnDate", label: "تاریخ برگشت" },
        {
          key: "proposalSubject",
          label: "طرح هایی که در آن شرکت داشته اید",
        },
        { key: "operation", label: "" },
      ],
      achievmentitems: [],
      achievmentFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد" },
        { key: "operation", label: "" },
      ],
      articlesItems: [],
      articlesFields: [
        { key: "index", label: "#" },
        { key: "subject", label: "عنوان" },
        { key: "releaseYear", label: "سال انتشار" },
        { key: "refrence", label: "تعداد ارجاع" },
        { key: "writersName", label: "نام نویسندگان" },
        { key: "magName", label: "نام مجله" },
        { key: "upload", label: "آپلود فایل" },
        { key: "operation", label: "" },
      ],
      proposalStudies: false,
      proposalDevelopment: false,
      proposalPractical: false,
      drPosition: ["مربی", "استادیار", "دانشیار", "استاد‌تمام"],
      committieType: ["وزارت علوم", "وزارت بهداشت"],
      lastDegree: ["کارشناسی", "کارشناسی ارشد", "دکتری"],
      support: "",
      supportSetad: "",
      selectedMehvar: 0,
      countries: [],
      taahol: "",
      max: 100,
      //myFile: JSON.parse(
      //  JSON.stringify(
      //    new Array(18).fill({
      //      isUploaded: false,
      //      uploadPercentage: 0,
      //    })
      //  )
      //),
      //myTempFile0: false,
      //myTempFile1: false,
      //myTempFile2: false,
      //myTempFile3: false,
      //myTempFile4: false,
      //myTempFile5: false,
      //myTempFile6: false,
      //myTempFile7: false,
      //myTempFile8: false,
      //myTempFile9: false,
      //myTempFile10: false,
      //myTempFile11: false,
      //myTempFile12: false,
      //myTempFile13: false,
      //myTempFile14: false,
      //myTempFile15: false,
      //myTempFile16: false,
      //myTempFile17: false,
      //myTempFile18: false,

      //descriptionTemplates: [
      //  {
      //    title: "",
      //    description: "رزومه سوابق علمی، تخصصی و تحقیقاتی استاد داخلی",
      //  },
      //  {
      //    title: "",
      //    description: "رزومه سوابق علمی، تخصصی و تحقیقاتی استاد خارجی",
      //  },
      //  { title: "", description: "رزومه متقاضی" },
      //  { title: "", description: "رزومه استاد خارجی" },
      //  { title: "", description: "مستندات شاخص Hindex" },
      //  { title: "", description: "مستندات آزمون جامع" },
      //  { title: "", description: "صورت جلسه تصویب پروپوزال" },
      //  { title: "", description: "فایل پروپوزال مصوب" },
      //  { title: "", description: "دعوتنامه کشور مقصد" },
      //  { title: "", description: "بلیط رفت" },
      //  { title: "", description: "بلیط برگشت" },
      //  { title: "", description: "ویزا" },
      //  { title: "", description: "گواهی استاد راهنما در سربرگ با امضا" },
      //  { title: "", description: "نامه درخواست معاونت پژوهش" },
      //  { title: "", description: "نامه شرکت دانش بنیان" },
      //  { title: "", description: "" },
      //  { title: "", description: "" },
      //  { title: "", description: "" },
      //  { title: "", description: "" },
      //],
      uploadedFiles: new Array(16).fill({
        file: null,
        isUploaded: false,
        uploadPercentage: 0,
      }),
      files: [
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          title: "",
          id: "",
        },
      ],

      fileFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان" },
        { key: "showName", label: "نام فایل" },
        { key: "url", label: "دریافت" },
      ],
      fileTitles: [
        "رزومه متقاضی",
        "رزومه استاد خارجی",
        "مستندات شاخص Hindex",
        "مستندات آزمون جامع",
        "صورت جلسه تصویب پروپوزال",
        "فایل پروپوزال مصوب",
        "دعوتنامه کشور مقصد",
        "بلیط رفت",
        "بلیط برگشت",
        "ویزا",
        "گواهی استاد راهنما در سربرگ با امضا",
        "نامه درخواست معاونت پژوهش",
        "نامه شرکت دانش بنیان",
        "سایر مدارک (1)",
        "سایر مدارک (2)",
        "سایر مدارک (3)",
      ],
      additionalFiles: {
        zero: { uploadPercentage: 0 },
        research: { uploadPercentage: 0 },
        industry: { uploadPercentage: 0 },
        agreement: { uploadPercentage: 0 },
        others1: { uploadPercentage: 0 },
        others2: { uploadPercentage: 0 },
        others3: { uploadPercentage: 0 },
      },
      otherFiles: new Array(10).fill({
        isUploaded: false,
      }),
      myshow: false,
      config: {
        locale: {
          name: "en",
        },

        height: 50,
        list: {
          rows: {},
          columns: {
            data: {
              id: {
                id: "id",
                data: "id",
                width: 50,
                header: {
                  content: "ردیف",
                },
              },
              label: {
                id: "label",
                data: "label",
                width: 200,
                header: {
                  content: "نام فعالیت",
                },
              },
              start: {
                id: "start",
                data: (start) => moment(start).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ آغاز",
                },
              },
              end: {
                id: "end",
                data: (end) => moment(end).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ پایان",
                },
              },
            },
          },
        },
        chart: {
          time: {
            zoom: 12,
          },
          items: {},
        },
      },
      background: [
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
      ],
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
      isLoaded: true,
      showTop: false,
      gettingMobile: false,
      supervisors: [
        {
          id: "",
          name: "",
          lastName: "",
          mobile: "",
          natCode: "",
          email: "",
          position: "",
          lastDegree: "",
          UniversityId: "",
          UniversityOther: "",
          UniversityJobId: "",
          UniversityJobOther: "",
          resumeFileId: "",
          resumeFile: "",
        },
      ],
      newSupervisor: {},
      advisors: [
        {
          id: "",
          name: "",
          lastName: "",
          mobile: "",
          email: "",
          position: "",
          lastDegree: "",
          UniversityOther: "",
          UniversityJobOther: "",
        },
      ],
    };
  },

  methods: {
    viewList(type) {
      localStorage.setItem("list", type);
      let link = "/map";
      window.open(link, "_blank");
    },
    getMobile() {
      this.gettingMobile = true;
      this.$http
        .post(
          this.baseUrl + "/setad/researcher/profile/mobile",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.gettingMobile = false;
          this.proposal.researcherMobile = res.data;
        })
        .catch((err) => {
          this.gettingMobile = false;
          console.log(err);
        });
    },
    getCompanyInfo() {
      if (this.proposal.companyId != this.notCompany) {
        this.proposal.companyName = this.companies.filter(
          (x) => x.id == this.proposal.companyId
        )[0].name;
        this.proposal.companyRegistrationNumber = this.companies.filter(
          (x) => x.id == this.proposal.companyId
        )[0].registrationNumber;
        this.proposal.companyNationalId = this.companies.filter(
          (x) => x.id == this.proposal.companyId
        )[0].nationalId;
      }
    },

    nameKeydown(e) {
      if (/[^a-zA-Z 0-9]/.test(e.key)) {
        e.preventDefault();
      }
    },
    changePage(direction) {
      // NOTE (m-changePage) to go to the previous and next step in each step
      direction == "back" ? this.tabIndex-- : this.tabIndex++;

      // Scroll to Top
      window.scrollTo(0, 0);
    },
    removeMehvar() {
      this.proposal.mehvarId = "";
      this.otherMehvars = "";
    },
    submit() {
      this.sending = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/request/opportune/fastSub",
          {
            requestId: this.$route.params.id,
            researcherId: this.proposal.researcherId,
            uploadedFiles: this.files,
            enSubject: this.proposal.enSubject,
            faSubject: this.proposal.faSubject,
            initialIsSupported: this.proposal.initialIsSupported,
            initialSupportedType: this.proposal.initialSupportedType,
            initialOtherSupport: this.proposal.initialOtherSupport,
            initialSupportDescription: this.proposal.initialSupportDescription,
            universityId: this.proposal.universityId,
            otherUniversity: this.proposal.otherUniversity,
            mehvarId: this.proposal.mehvarId,
            otherMehvars: this.proposal.otherMehvars,
            typeStudy: this.proposal.typeStudy,
            typeSystemicDevelopmental: this.proposal.typeSystemicDevelopmental,
            typePractical: this.proposal.typePractical,
            zoneMedicine: this.proposal.zoneMedicine,
            zoneAgriculture: this.proposal.zoneAgriculture,
            zoneEnvironment: this.proposal.zoneEnvironment,
            zoneIndustrial: this.proposal.zoneIndustrial,
            zoneBioComputing: this.proposal.zoneBioComputing,
            zoneOther: this.proposal.zoneOther,
            oppurtunityActions: this.proposal.oppurtunityActions,
            oppurtunityAchievements: this.proposal.oppurtunityAchievements,

            //researcher
            researcherName: this.proposal.researcherName,
            researcherLastName: this.proposal.researcherLastName,
            researcherMobile: this.proposal.researcherMobile,
            researcherEmail: this.proposal.researcherEmail,
            researcherNatCode: this.proposal.researcherNatCode,
            researcherFax: this.proposal.researcherFax,
            researcherCityId: this.proposal.researcherCityId ? this.proposal.researcherCityId : null,
            researcherStateId: this.proposal.researcherStateId ? this.proposal.researcherStateId : null,
            researcherUniversityId: this.proposal.researcherUniversityId,
            researcherUniversityOther: this.proposal.researcherUniversityOther,
            researcherUniversityJobId: this.proposal.researcherUniversityJobId,
            researcherUniversityJobOther:
              this.proposal.researcherUniversityJobOther,
            researcherHindex: this.proposal.researcherHindex,
            researcherComprehensiveTestMark:
              this.proposal.researcherMasterStudent == "student"
                ? this.proposal.researcherComprehensiveTestMark
                : "",
            researcherComprehensiveTestDate:
              this.proposal.researcherMasterStudent == "student"
                ? this.proposal.researcherComprehensiveTestDate
                : "",
            researcherMasterStudent: this.proposal.researcherMasterStudent,
            researcherArticleISI: this.proposal.researcherArticleISI,

            researcherIBAN: this.proposal.researcherIBAN,
            researcherBankName: this.proposal.researcherBankName,
            researcherUniversityDestination:
              this.proposal.researcherUniversityDestination,
            researcherCountryDestination:
              this.proposal.researcherCountryDestination,
            researcherHindex: this.proposal.researcherHindex,
            researcherPhDThesisSubject:
              this.proposal.researcherPhDThesisSubject,
            researcherPhDThesisDefenceDate:
              this.proposal.researcherPhDThesisDefenceDate,

            supervisors: this.supervisors,
            advisors: this.advisors,

            //company Info
            companyId:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyId
                : "",
            otherCompanyName:
              this.proposal.companyId == this.notCompany &&
              this.proposal.commercializingType == "company"
                ? this.proposal.otherCompanyName
                : "",
            otherCompanyRegistrationNumber:
              this.proposal.companyId == this.notCompany &&
              this.proposal.commercializingType == "company"
                ? this.proposal.otherCompanyRegistrationNumber
                : "",
            otherCompanyNationalId:
              this.proposal.companyId == this.notCompany &&
              this.proposal.commercializingType == "company"
                ? this.proposal.otherCompanyNationalId
                : "",
            companyName:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyName
                : "",
            companyRegistrationNumber:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyRegistrationNumber
                : "",
            companyNationalId:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyNationalId
                : "",
            companyProducts:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyProducts
                : "",
            companyContactInfo:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyContactInfo
                : "",
            companyDescription:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyDescription
                : "",

            commercializingType: this.proposal.commercializingType,
            commercializingObligation1:
              this.proposal.commercializingType == "none"
                ? this.proposal.commercializingObligation1
                : "",
            commercializingObligation2:
              this.proposal.commercializingType == "none"
                ? this.proposal.commercializingObligation2
                : "",
            acceleratorId:
              this.proposal.commercializingType == "accelerator"
                ? this.proposal.acceleratorId
                : "",

            //Scheduling
            gantData: this.proposal.gantData,
            duration:
              this.proposal.gantData.length > 0
                ? (Math.max(
                    ...this.proposal.gantData.map((x) =>
                      new Date(
                        moment(x.returnDate, "jYYYY/jMM/jDD").format(
                          "YYYY-MM-DD"
                        )
                      ).getTime()
                    )
                  ) -
                    Math.min(
                      ...this.proposal.gantData.map((x) =>
                        new Date(
                          moment(x.dispatchDate, "jYYYY/jMM/jDD").format(
                            "YYYY-MM-DD"
                          )
                        ).getTime()
                      )
                    )) /
                  3600 /
                  24 /
                  1000
                : 0,

            startDate:
              this.proposal.gantData.length > 0
                ? moment(
                    new Date(
                      Math.min(
                        ...this.proposal.gantData.map((x) =>
                          new Date(
                            moment(x.dispatchDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      )
                    )
                  ).format("jYYYY/jMM/jDD")
                : "",

            finalDate:
              this.proposal.gantData.length > 0
                ? moment(
                    new Date(
                      Math.max(
                        ...this.proposal.gantData.map((x) =>
                          new Date(
                            moment(x.returnDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      )
                    )
                  ).format("jYYYY/jMM/jDD")
                : "",

            //files
            researcherResumeFileId: this.proposal.researcherResumeFileId,
            foreignTeacherResumeFileId:
              this.proposal.foreignTeacherResumeFileId,
            hindexFileId: this.proposal.hindexFileId,
            comprehensiveTestFileId: this.proposal.comprehensiveTestFileId,
            minutesDefenceFileId: this.proposal.minutesDefenceFileId,
            proposalWordFileId: this.proposal.proposalWordFileId,
            invitationDestinationCountryFileId:
              this.proposal.invitationDestinationCountryFileId,
            onWayTicketFileId: this.proposal.onWayTicketFileId,
            returnTicketFileId: this.proposal.returnTicketFileId,
            visaFileId: this.proposal.visaFileId,
            certificateSupervisorFileId:
              this.proposal.certificateSupervisorFileId,
            letterRequestDeputyResearchFileId:
              this.proposal.letterRequestDeputyResearchFileId,
            letterCompanyFileId: this.proposal.letterCompanyFileId,

            otherFile1Id: this.proposal.otherFile1Id,
            otherFile1Title: this.proposal.otherFile1Title,
            otherFile1Description: this.proposal.otherFile1Description,
            otherFile2Id: this.proposal.otherFile2Id,
            otherFile2Title: this.proposal.otherFile2Title,
            otherFile2Description: this.proposal.otherFile2Description,
            otherFile3Id: this.proposal.otherFile3Id,
            otherFile3Title: this.proposal.otherFile3Title,
            otherFile3Description: this.proposal.otherFile3Description,

            promiseArrays: this.proposal.promiseArrays,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast("درخواست با موفقیت در سامانه به ثبت رسید.", "success");
          this.sending = false;
          router.push("/admin/opportunity/" + res.data);
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.sending = false;
        });
    },
    delFile(order, fileName) {
      this.uploadedFiles[order] = {
        file: null,
        isUploaded: false,
        uploadPercentage: 0,
      };
      this.files[order] = {
        showName: "",
        url: "",
        id: "",
      };
      this.proposal[fileName] = "";
      this.proposal[fileName + "Id"] = "";
    },
    changedStartDate(data, index) {
      if (
        moment(data.startDate, "jYYYY/jM/JD").format("X") >
        moment(data.dueDate, "jYYYY/jM/JD").format("X")
      ) {
        this.proposal.gantData[index].dueDate = this.computedMinDate(
          data.startDate
        );
      }
    },
    addArticle() {
      // NOTE (m-addService) to add service costs in the relevant sections
      this.proposal.researcherArticleISI.push({
        subject: "",
        releaseYear: "",
        refrence: "",
        writersName: "",
        magName: "",
        file: {
          uploadPercentage: 0,
          isUploaded: false,
        },
        uploadedFile: {},
      });
      const title = (
        <div>
          <h5>!مقاله جدید افزوده شد</h5>
          <span>لطفا اطلاعات هر مقاله را در جدول مربوطه تکمیل کنید</span>
        </div>
      );
      this.toast(title, "info");
    },
    delArticle(order) {
      // NOTE (m-delService) to remove services in the relevant sections
      this.proposal.researcherArticleISI.splice(order, 1);
    },
    add() {
      // NOTE (m-addAchievment) to add achievements in the relevant sections
      this.proposal.oppurtunityAchievements.push({
        name: "",
      });
      const title = (
        <div>
          <h5>!دستاورد جدید افزوده شد</h5>
          <span>لطفا اطلاعات دستاورد جدید را در جدول مربوطه تکمیل کنید</span>
        </div>
      );
      this.toast(title, "info");
    },
    remove(order) {
      // NOTE (m-delAchievment) to remove achievments in the relevant sections
      if (this.proposal.oppurtunityAchievements.length == 1) {
        const title = (
          <div>
            <h5>!خطا</h5>
            <span>حداقل یک فیلد دستاورد باید موجود باشد</span>
          </div>
        );
        this.toast(title, "error");
      } else {
        this.proposal.oppurtunityAchievements.splice(order, 1);
      }
    },
    addTime() {
      // NOTE (m-addAchievment) to add achievements in the relevant sections
      this.proposal.gantData.push({
        name: "",
        amount: "",
        fullfill: "",
      });
      const title = (
        <div>
          <h5>!مورد جدید افزوده شد</h5>
          <span>لطفا اطلاعات زمانبندی جدید را در جدول مربوطه تکمیل کنید</span>
        </div>
      );
      this.toast(title, "info");
    },
    showAcount() {
      this.$http
        .post(
          this.baseUrl + "/setad/admin/researcher/getInfo",
          {
            researcherId: this.proposal.researcherId,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.proposal.researcherName = "";
          this.proposal.researcherLastName = "";
          this.proposal.researcherNatCode = "";
          this.proposal.researcherMobile = "";
          this.proposal.researcherFax = "";
          this.proposal.researcherEmail = "";
          this.proposal.researcherState = "";
          this.proposal.researcherCity = "";
          this.proposal.researcherStateId = "";
          this.proposal.researcherCityId = "";
          this.proposal.researcherUniversityId = "";
          this.proposal.researcherUniversityJobId = "";
          this.proposal.researcherLastDegree = "";
          //////////////////////////////////////////
          this.executor = res.data.researcher;
          this.proposal.researcherName = this.executor.name;
          this.proposal.researcherLastName = this.executor.lastName;
          this.proposal.researcherNatCode = this.executor.natCode;
          this.proposal.researcherMobile = this.executor.mobile;
          this.proposal.researcherFax = this.executor.fax;
          this.proposal.researcherEmail = this.executor.email;
          this.proposal.researcherState = this.executor.state;
          this.proposal.researcherCity = this.executor.city;
          this.proposal.researcherStateId = this.executor.stateId;
          this.proposal.researcherCityId = this.executor.cityId;
          this.proposal.researcherUniversityId = this.executor.universityId;
          this.proposal.researcherUniversityJobId =
            this.executor.universityJobId;
          this.proposal.researcherLastDegree = this.executor.lastDegree;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    removeTime(order) {
      // NOTE (m-delAchievment) to remove achievments in the relevant sections
      if (this.proposal.gantData.length == 1) {
        const title = (
          <div>
            <h5>!خطا</h5>
            <span>حداقل یک فیلد دستاورد باید موجود باشد</span>
          </div>
        );
        this.toast(title, "error");
      } else {
        this.proposal.gantData.splice(order, 1);
      }
    },
    uploadFile(file, index, fileName) {
      // NOTE to upload files
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        this.uploadedFiles[index].showProgress = true;
        this.uploadedFiles[index].variant = "info";
        this.uploadedFiles[index].uploadPercentage = 0;
        this.uploadedFiles[index].isUploaded = false;
        this.uploadedFiles[index].uploadButDisable = true;

        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl + "/setad/admin/request/opportune/upload",
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.uploadedFiles[index].uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((d) => {
            if (d.status == 200) {
              this.uploadedFiles[index].isUploaded = true;
              this.uploadedFiles[index].uploadPercentage = 100;
              this.uploadedFiles[index].striped = false;
              this.uploadedFiles[index].variant = "success";
              this.uploadedFiles[index].uploadButDisable = false;
              this.proposal[fileName] = d.data.url;
              this.proposal[fileName + "Id"] = d.data.id;
              this.files[index] = d.data;
              this.files[index].title = this.fileTitles[index];

              // this.uploadedFiles[index].title = d.data[0].showName;
              // this.uploadedFiles[index].description =
              //   this.descriptionTemplates[index].description;

              // this.research = this.uploadedFiles[1]
              //   ? this.uploadedFiles[1].name
              //   : false;
              // this.industry = this.uploadedFiles[2]
              //   ? this.uploadedFiles[2].name
              //   : false;
              // this.agreement = this.uploadedFiles[3]
              //   ? this.uploadedFiles[3].name
              //   : false;
              // this.account = this.uploadedFiles[7]
              //   ? this.uploadedFiles[7].name
              //   : false;

              this.$forceUpdate();
            }
          })
          .catch((err) => {
            console.log(err);
            this.uploadedFiles[index].uploadPercentage = 0;
            this.uploadedFiles[index].isUploaded = false;
          });
      }
    },
    supUploadFile(file) {
      // NOTE  to upload colleagues files
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        this.supervisors[0].showProgress = true;
        this.supervisors[0].variant = "info";
        this.supervisors[0].uploadPercentage = 0;
        this.supervisors[0].isUploaded = false;
        this.supervisors[0].uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl + "/setad/admin/request/opportune/upload",
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.supervisors[0].uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((d) => {
            if (d.status == 200) {
              this.supervisors[0].isUploaded = true;
              this.supervisors[0].uploadPercentage = 100;
              this.supervisors[0].striped = false;
              this.supervisors[0].variant = "success";
              this.supervisors[0].uploadButDisable = false;
              this.supervisors[0].resumeFile = d.data.url;
              this.supervisors[0].resumeFileId = d.data.id;
              this.$forceUpdate();
            }
          })
          .catch((err) => {
            console.log(err);
            this.supervisors[0].file = null;
            this.supervisors[0].uploadPercentage = 0;
            this.supervisors[0].isUploaded = false;
          });
      }
    },
    advUploadFile(file, index) {
      // NOTE  to upload colleagues files
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        this.advisors[0].showProgress = true;
        this.advisors[0].variant = "info";
        this.advisors[0].uploadPercentage = 0;
        this.advisors[0].isUploaded = false;
        this.advisors[0].uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl + "/setad/admin/request/opportune/upload",
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.supervisors[0].uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((d) => {
            if (d.status == 200) {
              this.supervisors[0].isUploaded = true;
              this.supervisors[0].uploadPercentage = 100;
              this.supervisors[0].striped = false;
              this.supervisors[0].variant = "success";
              this.supervisors[0].uploadButDisable = false;
              this.supervisors[0].resumeFile = d.data.url;
              this.supervisors[0].resumeFileId = d.data.id;
              this.$forceUpdate();
            }
          })
          .catch((err) => {
            console.log(err);
            this.supervisors[0].file = null;
            this.supervisors[0].uploadPercentage = 0;
            this.supervisors[0].isUploaded = false;
          });
      }
    },

    //myUpload(file, index) {
    //  if (!file) {
    //    return;
    //  }
    //  //CHECK FILE SIZE
    //  let sizeMB = file.size / 1024 / 1024;

    //  if (sizeMB > 5) {
    //    this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
    //    return;
    //  } else {
    //    // START UPLOAD PROCESS
    //    this.myFile[index].showProgress = true;
    //    this.myFile[index].variant = "info";
    //    this.myFile[index].uploadPercentage = 0;
    //    this.myFile[index].isUploaded = false;
    //    this.myFile[index].uploadButDisable = true;
    //    var formData = new FormData();
    //    formData.append(file.name, file);

    //    this.$http
    //      .post(
    //        this.baseUrl +
    //          "/setad/newUploads/private?id=" +
    //          this.$route.params.id,
    //        formData,
    //        {
    //          headers: {
    //            Authorization: "Bearer: " + localStorage.getItem("userId"),
    //          },
    //          onUploadProgress: ((progressEvent) => {
    //            this.myFile[index].uploadPercentage =
    //              Math.round(
    //                (progressEvent.loaded * 100) / progressEvent.total
    //              ) - 1;
    //          }).bind(this),
    //        }
    //      )
    //      .then((res) => {
    //        if (res.status == 200) {
    //          this.myFile[index].isUploaded = true;
    //          this.myFile[index].uploadPercentage = 100;
    //          this.myFile[index].striped = false;
    //          this.myFile[index].variant = "success";
    //          this.myFile[index].uploadButDisable = false;
    //          this.uploadedFiles[index] = res.data[0];

    //          this.uploadedFiles.forEach((x, index) => {
    //            if (x) this["myTempFile" + index] = true;
    //            else this["myTempFile" + index] = false;
    //          });

    //          if (index > 14) {
    //            this.uploadedFiles[index].title =
    //              this.descriptionTemplates[index].title;
    //            this.uploadedFiles[index].description =
    //              this.descriptionTemplates[index].description;
    //          } else {
    //            this.uploadedFiles[index].title = res.data[0].showName;
    //            this.uploadedFiles[index].description =
    //              this.descriptionTemplates[index].description;
    //          }
    //        }
    //      })
    //      .catch((err) => {
    //        console.log(err)
    //        this.uploadedFiles[index] = "";
    //        this.file[index] = null;
    //        this.myFile[index].uploadPercentage = 0;
    //        this.myFile[index].isUploaded = false;
    //        this.myFile[index].showProgress = false;
    //        this["myTempFile" + index] = false;
    //      });
    //  }
    //},
    articleUpload(file, index) {
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        // file.splice(this.file.indexOf('$path'), 1);
        this.proposal.researcherArticleISI[index].file.showProgress = true;
        this.proposal.researcherArticleISI[index].file.variant = "info";
        this.proposal.researcherArticleISI[index].file.uploadPercentage = 0;
        this.proposal.researcherArticleISI[index].file.isUploaded = false;
        this.proposal.researcherArticleISI[index].file.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl + "/setad/admin/request/opportune/upload",
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.proposal.researcherArticleISI[
                  index
                ].file.uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((res) => {
            if (res.status == 200) {
              this.proposal.researcherArticleISI[index].file.isUploaded = true;
              this.proposal.researcherArticleISI[
                index
              ].file.uploadPercentage = 100;
              this.proposal.researcherArticleISI[index].file.striped = false;
              this.proposal.researcherArticleISI[index].file.variant =
                "success";
              this.proposal.researcherArticleISI[
                index
              ].file.uploadButDisable = false;
              this.proposal.researcherArticleISI[index].uploadedFile = res.data;
              this.$forceUpdate();
            }
          })
          .catch((err) => {
            console.log(err);
            this.proposal.researcherArticleISI[index].uploadedFile = "";
            this.proposal.researcherArticleISI[index].file.file = null;
            this.proposal.researcherArticleISI[index].file.isUploaded = false;
            this.proposal.researcherArticleISI[index].file.showProgress = false;
            this.proposal.researcherArticleISI[index].file.uploadPercentage = 0;
          });
      }
    },
    isEmail(email) {
      // NOTE (m-isEmail) to check the validity of the email
      return email ? (this.validateEmail(email) ? null : false) : null;
    },
    isID(id) {
      // NOTE to check the validity of the national code
      return id ? (this.checkCodeMeli(id) ? null : false) : null;
    },
    isEmailClass(email) {
      // NOTE (m-isEmail) to check the validity of the email
      return email ? (this.validateEmail(email) ? true : false) : false;
    },
    isIDClass(id) {
      // NOTE to check the validity of the national code
      return id ? (this.checkCodeMeli(id) ? true : false) : false;
    },
    addAchievment() {
      // NOTE (m-addAchievment) to add achievements in the relevant sections
      this.proposal.oppurtunityAchievements.push({
        name: "",
        amount: "",
        fullfill: "",
      });
      const title = (
        <div>
          <h5>!دستاورد جدید افزوده شد</h5>
          <span>لطفا اطلاعات دستاورد جدید را در جدول مربوطه تکمیل کنید</span>
        </div>
      );
      this.toast(title, "info");
    },
    delAchievment(order) {
      // NOTE (m-delAchievment) to remove achievments in the relevant sections
      if (this.proposal.oppurtunityAchievements.length == 1) {
        const title = (
          <div>
            <h5>!خطا</h5>
            <span>حداقل یک فیلد دستاورد باید موجود باشد</span>
          </div>
        );
        this.toast(title, "error");
      } else {
        this.proposal.oppurtunityAchievements.splice(order, 1);
      }
    },
    addService() {
      // NOTE (m-addService) to add service costs in the relevant sections
      this.proposal.gantData.push({
        description: "",
        percent: 0,
        startDate: moment(new Date()).format("jYYYY/jMM/jDD"),
        dueDate: moment(new Date()).add(1, "day").format("jYYYY/jMM/jDD"),
        cellColor: "blue",
      });
      const title = (
        <div>
          <h5>!فاز جدید افزوده شد</h5>
          <span>
            لطفا اطلاعات هر فاز را در جدول مربوطه تکمیل کنید و به منظور
            بروزرسانی گانت چارت روی دکمه بروزرسانی کلیک کنید
          </span>
        </div>
      );
      this.toast(title, "info");
      this.myshow = !this.myshow;
    },
    delService(order) {
      // NOTE (m-delService) to remove services in the relevant sections
      this.proposal.gantData.splice(order, 1);
    },
    onMounted() {
      this.pageLoaded = false;
      this.uploadedFiles = JSON.parse(JSON.stringify(this.uploadedFiles));
      this.files = JSON.parse(JSON.stringify(this.files));
      let acc = 0;

      this.$bvModal.show("loading");
      this.isLoaded = false;

      //getting universities
      this.$http
        .post(
          this.baseUrl + "/setad/options/universities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.universities = res.data;
          this.universities.push(
            new Object({
              id: this.notUniversity,
              text: "سایر دانشگاه ها",
            })
          );
          this.universities.unshift({
            id: 0,
            text: "--گزینه مورد نظر خود را انتخاب نمایید--",
            disabled: "true",
          });

          acc++;

          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");

              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
          }
        })
        .catch((err) => {
          console.log(err);
        });
      this.$http
        .post(
          this.baseUrl + "/setad/admin/researchers/select",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.researchers = res.data.map((x) => {
            return {
              id: x.id,
              text: x.name,
            };
          });

          this.researchers.unshift({
            id: 0,
            text: "--پژوهشگر مورد نظر خود را انتخاب نمایید--",
            disabled: "true",
          });

          this.$bvModal.hide("loading");
          this.isLoaded = true;
        }),
        //getting companies
        this.$http
          .post(
            this.baseUrl + "/setad/options/companies",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.companies = res.data;
            this.companies.forEach((x) => {
              x.text = x.name;
            });
            this.companies.push(
              new Object({
                id: this.notCompany,
                text: "سایر شرکت‌ها",
              })
            );
            this.companies.unshift({
              id: 0,
              text: "--گزینه مورد نظر خود را انتخاب نمایید--",
              disabled: "true",
            });

            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
            }
          })
          .catch((err) => {
            console.log(err);
          });

      // getting accelerators
      this.$http
        .post(
          this.baseUrl + "/setad/options/accelerators",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.accelerators = res.data;
          this.accelerators.forEach((x) => {
            x.text = x.name;
          });
        })
        .catch((err) => {
          console.log(err);
        });

      //getting mehvars
      this.$http
        .post(
          this.baseUrl + "/setad/options/uniMehvars",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.mehvars = res.data;
          acc++;

          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getStatesAndCities() {
      this.$http
        .get(this.baseUrl + "/setad/public/states/list", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.iran = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCountries() {
      this.$http
        .post(
          this.baseUrl + "/setad/options/countries",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.countries = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },

  computed: {
    // NOTE unuversity class if the university was "سایر"

    universityClass() {
      if (this.proposal.researcherUniversityId == this.notUniversity) {
        if (this.proposal.researcherUniversityOther) {
          return "done";
        } else {
          return "required";
        }
      } else {
        if (this.proposal.researcherUniversityId) {
          return "done";
        } else {
          return "required";
        }
      }
    },
    universityJobClass() {
      if (this.proposal.researcherUniversityJobId == this.notUniversity) {
        if (this.proposal.researcherUniversityJobOther) {
          return "done";
        } else {
          return "required";
        }
      } else {
        if (this.proposal.researcherUniversityJobId) {
          return "done";
        } else {
          return "required";
        }
      }
    },
    colleagueUniversityClass() {
      if (this.supervisors[0].universityId == this.notUniversity) {
        if (this.supervisors[0].universityOther) {
          return "done";
        } else {
          return "required";
        }
      } else {
        if (this.supervisors[0].universityId) {
          return "done";
        } else {
          return "required";
        }
      }
    },
    colleagueUniversityJobClass() {
      if (this.supervisors[0].universityJobId == this.notUniversity) {
        if (this.supervisors[0].universityJobOther) {
          return "done";
        } else {
          return "required";
        }
      } else {
        if (this.supervisors[0].universityJobId) {
          return "done";
        } else {
          return "required";
        }
      }
    },
    computedTitle1() {
      if (this.proposal.companyId) {
        if (this.proposal.companyId != this.notCompany) {
          return true;
        } else {
          if (this.proposal.otherCompanyRegistrationNumber) {
            return true;
          } else return false;
        }
      } else {
        return false;
      }
    },
    computedTitle2() {
      if (this.proposal.companyId) {
        if (this.proposal.companyId != this.notCompany) {
          return true;
        } else {
          if (this.proposal.otherCompanyNationalId) {
            return true;
          } else return false;
        }
      } else {
        return false;
      }
    },

    achievmentItemsClass() {
      let progress = 0;
      let total = 0; //default number of price variables due to last table

      if (this.proposal.oppurtunityAchievements) {
        total += this.proposal.oppurtunityAchievements.length;
        this.proposal.oppurtunityAchievements.forEach((x) => {
          x.name ? progress++ : 1;
        });
        if (total / progress == 1) {
          return "done";
        } else {
          return "required";
        }
      } else {
        return "required";
      }
    },

    computedMaxDate(dueDate) {
      // REVIEW (m-computedMaxDate)
      let m = moment(dueDate, "jYYYY/jM/jD");
      m.subtract(1, "day");

      return m.format("jYYYY/jM/jDD");
    },
    computedMinDate(startDate) {
      // REVIEW (m-computedMinDate)
      let m = moment(startDate, "jYYYY/jM/jD");
      m.add(1, "day");

      return m.format("jYYYY/jM/jDD");
    },
    originUni() {
      let temp = "";
      try {
        temp = this.universities.filter(
          (x) => x.id == this.proposal.universityId
        )[0].text;
      } catch (error) {
        temp = "لطفا دانشگاه محل اجرای دوره را انتخاب کنید";
      }
      return temp;
    },
    computedMehvars() {
      // NOTE (c-computedMehvars) to after selecting university show to user list of mehvars of selected university
      let mehvarha = [];
      if (this.proposal.universityId) {
        mehvarha = this.mehvars.filter(
          (x) => x.universityId == this.proposal.universityId
        );
        if (this.proposal.universityId != this.notUniversity) {
          this.proposal.mehvarId = this.proposal.mehvarId;
        } else if (this.proposal.universityId == this.notUniversity) {
          this.proposal.mehvarId = this.notMehvar;
        }
      }

      if (this.proposal.universityId) {
        mehvarha.push(
          new Object({
            id: this.notMehvar,
            text: "سایر محورها",
            universityId: this.proposal.universityId,
          })
        );
      } else {
        mehvarha.push(
          new Object({
            id: 0,
            text: "لطفا ابتدا یک دانشگاه انتخاب کنید",
            universityId: this.proposal.universityId,
          })
        );
      }
      if (this.proposal.mehvarId)
        this.selectedMehvar = mehvarha.findIndex(
          (x) => x.id == this.proposal.mehvarId
        );
      else this.selectedMehvar = "-";
      // alert(mehvarha.map(y=>y.id))
      // this.proposal.mehvarId ? this.selectedMehvar = mehvarha.map(y=>y.id).findIndexOf(this.proposal.mehvarId) : this.selectedMehvar = ''
      return mehvarha;
    },
  },
  mounted() {
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
    this.getStatesAndCities();
    this.getCountries();
    this.onMounted();
  },
};
</script>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.btn-dark {
  color: #fff !important;
  background-color: #4b285d !important;
  border-color: #4b285d !important;
}
.btn-light {
  color: #fff !important;
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-warning {
  color: #fff !important;
  background-color: #8341a4 !important;
  border-color: #8341a4 !important;
}
.btn-info {
  color: #fff !important;
  background-color: #a557cb !important;
  border-color: #a557cb !important;
}
.btn:hover {
  color: #fff !important;
  background-color: #999999 !important;
  border-color: #b173a2 !important;
}

.table-column {
  min-width: 100px;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #8341a4;
  border-bottom: 1px solid #8341a4;
}
.btn-secondary {
  background-color: #83819b;
  border-color: #9b8195;
}
</style>
<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}
</style>
